<template>
  <el-container class="organization">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicFoldSearch :searchList='searchList' v-on:getSearchObj='getSearchObj' :rightEventList='rightEventList'
        @rightFunc='rightFunc' />
    </div>
    <el-main class="organization-content" style="padding-bottom: 0">
      <!-- 中间列表数据 -->
      <BaseTable :data="tableData" :column="userPlatForm == 'platForm' ? homeColumnConfig : homeColumnConfig1"
        pagination :auto-scroll="true" :total="totalPage" :page.sync="searchParams.current"
        @selection-change="selectionChange" :limit.sync="searchParams.size" @pagination="getList">
      </BaseTable>
    </el-main>

    <el-dialog center width="900px" :title="newAdd?'新增医护信息':'查看医护信息'" v-if="dialogVisible" :visible.sync="dialogVisible"
      :close-on-click-modal="false" :destroy-on-close="true" @close="closeModule">
      <el-steps :active="active" finish-status="success" align-center>
        <el-step title="基本信息"></el-step>
        <el-step title="归属团队"></el-step>
        <el-step title="资质信息上传"></el-step>
        <el-step title="信息确认"></el-step>
      </el-steps>
      <div class="top-tabs" v-if="active==3||!newAdd">
        <div :class="activeName1==1?'tabs-cliked':''" @click="handleTabClick(1)">
          <span>基本信息</span>
        </div>
        <div :class="activeName1==2?'tabs-cliked':''" @click="handleTabClick(2)">
          <span>归属团队</span>
        </div>
        <div :class="activeName1==3?'tabs-cliked':''" @click="handleTabClick(3)">
          <span>资质信息上传</span>
        </div>
        <div>
        </div>
      </div>
      <div v-cloak v-if="active==0 || (active==3 && activeName1==1)" key="100">
        <div class="line-div">
          <span></span>
          <span>
            基本信息
          </span>
        </div>
        <template v-if="active!=3">
          <el-form ref="addForm" @submit.native.prevent :model="information1" label-width="140px" :rules="rules">
            <el-form-item label="医护照片: " required>
              <BaseUploadFile :fileSize="6" :isShowTip="false" :cropWidth="100" :cropHeight="100" :size="60"
                :action="VUE_APP_BASE_URL" :responseFn="handleMessageResponse2" :data="{ path: 'dsicm-doctor' }"
                v-model="upavater">
              </BaseUploadFile>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名: " prop="realName">
                  <el-input v-model.trim="information1.realName" placeholder="请输入你的真实姓名">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号: " prop="mobile">
                  <el-input v-model="information1.mobile" maxlength="11" placeholder="请输入11位有效数字"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="医护类型: " prop="doctorType">
                  <el-select v-model="information1.doctorType" placeholder="请选择医护类型" @change="selectDoctorType">
                    <el-option label="医生" :value="1"></el-option>
                    <el-option label="护士" :value="2"></el-option>
                    <!-- <el-option label="医技" :value="3"></el-option> -->
                    <el-option v-if="userPlatForm == 'platForm'" label="药师" :value="4"></el-option>
                    <el-option label="医辅" :value="6"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职称: " prop="titleId">
                  <el-select v-model="information1.titleId" @change="doctorTitleChange" placeholder="请选择职称">
                    <el-option v-for="(item, index) in doctorTitleList" :key="index" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="身份证号: " prop="idCard">
                  <el-input v-model="information1.idCard" placeholder="请输入你的身份证号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="userPlatForm == 'platForm'&&information1.doctorType != 4">
                <el-form-item label="线下机构: " prop="hospitalId" v-if="information1.doctorType==4">
                  <el-select v-model="information1.hospitalId" clearable filterable @change="hospitalChange"
                    placeholder="请输入关键词搜索线下机构">
                    <el-option v-for="(item, index) in hospitalList" :key="index" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="线下机构: " prop="hospitalId" v-else
                  :rules="{required:true,message: '请选择线下医院',trigger: 'change'}">
                  <el-select v-model="information1.hospitalId" clearable filterable @change="hospitalChange"
                    placeholder="请输入关键词搜索线下机构">
                    <el-option v-for="(item, index) in hospitalList" :key="index" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" v-if="information1.doctorType != 4">
                <el-form-item label="线下科室: " prop="departmentId" v-if="information1.doctorType==4">
                  <el-cascader ref="Mycascader" @change="departmentChange()" filterable placeholder="请输入关键词搜索线下科室"
                    v-model="information1.departmentId" :options="departmentList" clearable
                    :props="SetKesDept"></el-cascader>
                </el-form-item>
                <el-form-item label="线下科室: " v-else prop="departmentId"
                  :rules="{required:true,message: '请选择线下科室',trigger: 'change'}">
                  <el-cascader ref="Mycascader" @change="departmentChange()" filterable placeholder="请输入关键词搜索线下科室"
                    v-model="information1.departmentId" :options="departmentList" clearable
                    :props="SetKesDept"></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="专业擅长: " prop="professional" v-if="information1.doctorType==1">
              <el-input v-model="information1.professional" placeholder="请输入专业擅长" type="textarea"
                resize="none"></el-input>
            </el-form-item>
            <el-form-item label="医生介绍: " prop="note" v-if="information1.doctorType==1">
              <el-input resize="none" type="textarea" placeholder="请输入医生介绍" v-model="information1.note">
              </el-input>
            </el-form-item>
            <el-form-item v-if="information1.doctorType==2" label="护士上门服务: " prop="provideNursingService">
              <el-radio-group v-model="information1.provideNursingService" @change="redioChange()">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="护士上门服务地理范围(KM): " prop="serviceScopeKm"
              v-if="information1.doctorType==2 && information1.provideNursingService" class="lH20">
              <div style="display:flex">
                <el-input v-model.trim="information1.serviceScopeKm" @input="inputNumber"
                  placeholder="请输入服务范围（km）"></el-input>
                <div style="color:red;width:300px;font-size:12px">（以归属医院地址为中心点）</div>
              </div>

            </el-form-item>

          </el-form>
          <span class="dialog-footer">
            <el-button class="dialog-btn" size="small" @click="closeaddCare1()">重置</el-button>
            <el-button class="dialog-btn" size="small" type="primary" @click="submiAddCare1('addForm')">下一步</el-button>
          </span>
        </template>
        <template v-else>
          <el-form label-width="100px">
            <el-form-item label="医护照片: ">
              <el-image style="width: 60px; height: 60px;margin-right:10px" :src="upavater" :z-index="2003">
              </el-image>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名: " prop="realName">
                  <span>{{information1.realName}}</span>

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号: " prop="mobile">
                  <span>{{information1.mobile}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="医护类型: " prop="doctorType">
                  <span>{{information1.doctorType==1?'医生':information1.doctorType==2?'护士':information1.doctorType==6?'医辅':'药师'}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职称: " prop="titleId">
                  <span>{{information1.titleName?information1.titleName:'暂无数据'}}</span>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="身份证号: " prop="idCard">
                  <span>{{information1.idCard}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="线下机构: " v-if="userPlatForm == 'platForm'" placeholder="请选择线下机构" prop="hospitalId">
                  <span>{{information1.hospitalName?information1.hospitalName:'暂无数据'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="线下科室: " prop="departmentId">
                  <span>{{information1.departmentName?information1.departmentName:'暂无数据'}}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="专业擅长: " prop="professional" v-if="information1.doctorType==1">
              <span>{{information1.professional ? information1.professional:'暂无数据'}}</span>
            </el-form-item>
            <el-form-item label="医生介绍: " prop="note" v-if="information1.doctorType==1">
              <span>{{information1.note?information1.note:'暂无数据'}}</span>
            </el-form-item>
            <el-form-item label="护士上门服务: " prop="provideNursingService" v-if="information1.doctorType == 2">
              <span>{{information1.provideNursingService?'是':'否'}}</span>
            </el-form-item>
            <el-form-item label="护士上门服务地理范围(KM): " class="lH20" prop="serviceScopeKm"
              v-if="information1.doctorType == 2&&information1.provideNursingService">
              <span>{{information1.serviceScopeKm?information1.serviceScopeKm:'暂无数据'}}</span>
            </el-form-item>

          </el-form>
        </template>

      </div>
      <div v-if="(active==1&&newAdd)|| (newAdd && active==3 && activeName1==2)" key="200">
        <div class="line-div">
          <span></span>
          <span>
            归属团队
          </span>
        </div>
        <template v-if="active!=3 || (!newAdd&&!isEdit)">
          <el-form @submit.native.prevent>
            <el-form-item label-width="120px" label="是否归属团队: " required>
              <el-radio-group v-model="newSelectTteam" :disabled="information1.doctorType==4"
                @change="radioChangeGrounp" style="margin-left: 20px;">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div v-if="newSelectTteam">
            <!-- <el-radio-group > -->
            <div style="display: flex;align-items: center;">

              <el-radio :label="1" v-model="doctorTeam.type" @change="radioChangeGrounp">
                <span>加入其他团队</span>
              </el-radio>
              <el-select style="width: 290px;" v-model="doctorTeam.id" :disabled="doctorTeam.type!=1"
                @change="doctorTeamChange" size="medium" filterable placeholder="请输入关键词搜索你要加入的团队名称">
                <el-option v-for="item in doctorTeamList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div v-if="doctorTeam.type==1&&information1.doctorType==1"
              style="display: flex;align-items: center;line-height: 36px;margin-top: 20px ;">
              <label style="width: 140px;text-align: right;padding-right: 30px;">
                成员性质:
              </label>
              <div>
                <el-radio v-model="isMdt" :label="false">执行医生</el-radio>
                <el-radio v-model="isMdt" :label="true">MDT会诊</el-radio>
              </div>
            </div>
            <div style="display: flex;align-items: center;margin-top: 30px;" v-if="information1.doctorType != 6">
              <el-radio :label="2" v-model="doctorTeam.type" @change="radioChangeGrounp">独立团队</el-radio>
              <span style="font-size: 12px;color: #999;">*
                选择独立团队，即默认该护士为团队护士长/该医生为领衔专家，护士长后续可在医护团队管理页面进行调整，领衔专家不可修改~</span>
            </div>
            <el-form @submit.native.prevent label-width="120px" style="margin-top: 20px;"
              v-if="information1.doctorType != 6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="团队名称：" required>
                    <el-input maxlength="12" style="padding-left: 8px;" :disabled="doctorTeam.type!=2"
                      v-model="doctorTeam.name" placeholder="请输入团队名称">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="userPlatForm == 'platForm'">
                  <el-form-item label="线下机构：" required>
                    <!-- <el-select style="padding-left: 8px;"
														:disabled="true"
														v-model="doctorTeam.hospitalId"
														filterable
														@change="selectPlatformChange" size="medium" filterable
														placeholder="请输入关键词搜索归属平台">
														<el-option
														v-for="item in platformOptions" 
														:key="item.id" 
														:label="item.name" 
														:value="item.id"> 
														</el-option>
													</el-select> -->
                    <el-input style="padding-left: 8px;" :disabled="true" v-model="doctorTeam.hospitalName">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="线下科室：" required>
                    <el-cascader style="padding-left: 8px;" :disabled="doctorTeam.type!=2" filterable ref="Mycascader1"
                      v-model="doctorTeam.openDepartmentId" @change="departmentTeamChange" :options="departmentList1"
                      :props="setKesDept" placeholder="请选择线下科室">
                    </el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="个案组：" required>
                    <el-select style="padding-left: 8px;" :disabled="doctorTeam.type!=2" @change="caseMgrGroupChange"
                      v-model="doctorTeam.caseMgrGroupId" size="medium" filterable placeholder="请输入关键词搜索归属平台">
                      <el-option v-for="item in caseMgrGroupList" :key="item.id" :label="item.reGroupName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-form>
            <!-- </el-radio-group> -->

          </div>
        </template>
        <template v-else>
          <div class="team-item" v-if="!newSelectTteam" style="font-weight: 600;font-size: 12px;line-height: 20px;">暂无团队
          </div>
          <div class="team-item" v-if="newSelectTteam&&doctorTeam.type==2">
            <h3 style="font-weight: 600;color: #1A7BFC;line-height: 20px;">独立团队</h3>
            <ul>
              <li>
                <label>团队名称：</label>
                <span>{{doctorTeam.name}}</span>
              </li>
              <li>
                <label>线下机构：</label>
                <span>{{doctorTeam.hospitalName ? doctorTeam.hospitalName : orgName }}</span>
              </li>
              <li>
                <label>线下科室：</label>
                <span>{{doctorTeam.departmentName}}</span>
              </li>
              <li>
                <label>个案组：</label>
                <span>{{doctorTeam.caseMgrGroupName}}</span>
              </li>
            </ul>
          </div>
          <div class="team-item" v-if="newSelectTteam&&doctorTeam.type==1">
            <h3 style="font-weight: 600;color: #1A7BFC;line-height: 20px;">加入其他团队</h3>
            <ul>
              <li>
                <label>团队名称：</label>
                <span>{{doctorTeam.doctorTeamName}}</span>
              </li>

            </ul>
          </div>
        </template>
        <span class="dialog-footer" v-if="newAdd&&active==1">
          <el-button class="dialog-btn" size="small" @click="closeaddCare2()">重置</el-button>
          <el-button class="dialog-btn" size="small" @click="PreviousStep()" plain>上一步</el-button>
          <el-button class="dialog-btn" size="small" type="primary" @click="submiAddCare2()">下一步</el-button>
        </span>
      </div>
      <div v-if="(active==2&&newAdd)|| (newAdd && active==3 && activeName1==3)" key="300" class="info-upload">
        <div class="line-div">
          <span></span>
          <span>
            资质信息上传
          </span>
        </div>
        <el-form label-width="150px" ref="infoUpload" :rules="{}" :model="doctorCertificateSubmitDTO"
          @submit.native.prevent>
          <template v-if="active!=3 || (!newAdd&&isEdit)">
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>身份证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;">
              <el-col :span="12">
                <el-form-item label="国徽面：" required>
                  <BaseUploadFile :multiple="false" :fileSize="6" :isShowTip="false" :size="279" :height="138"
                    :action="VUE_APP_BASE_URL1" :beforeRemove="handleMessage3beforeRemove"
                    :responseFn="handleMessageResponse3" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.idCard.back">

                  </BaseUploadFile>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="头像面：" required>
                  <BaseUploadFile :multiple="false" :fileSize="6" :isShowTip="false" :size="279" :height="138"
                    :action="VUE_APP_BASE_URL1" :beforeRemove="handleMessage4beforeRemove"
                    :responseFn="handleMessageResponse4" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.idCard.front">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>资格证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：" required>
                  <el-date-picker style="width: 100%;" v-model="doctorCertificateSubmitDTO.qualification.obtainDate"
                    type="date" size="large" value-format="yyyy-MM-dd" placeholder="选择发证日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: " required>

                  <el-input maxlength="50" v-model="doctorCertificateSubmitDTO.qualification.number"
                    placeholder="请输入证书编号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24" class="tip-zhengshu">
                <el-form-item label="上传图片：" required>
                  <BaseUploadFile :fileSize="6" :size="60" :limit="9" :isShowTip="false" message="* 最少上传2张，最多上传9张"
                    :checkMore="true" :beforeRemove="certificateQualificationbeforeRemove"
                    :responseFn="certificateQualificationResponse" :action="VUE_APP_BASE_URL1"
                    :data="{ path: 'dsicm-doctor' }" v-model="doctorCertificateSubmitDTO.qualification.files">
                  </BaseUploadFile>
                </el-form-item>
                <!-- <span>* 最少上传2张，最多上传9张</span> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>执业证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：" required>
                  <el-date-picker style="width: 100%;" v-model="doctorCertificateSubmitDTO.practice.obtainDate"
                    type="date" size="large" value-format="yyyy-MM-dd" placeholder="选择发证日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: " required>
                  <el-input maxlength="50" v-model="doctorCertificateSubmitDTO.practice.number"
                    placeholder="请输入证书编号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24" class="tip-zhengshu">
                <el-form-item label="上传图片：" required>
                  <BaseUploadFile :fileSize="6" :size="60" :limit="9" :isShowTip="false" message="* 最少上传2张，最多上传9张"
                    :checkMore="true" :beforeRemove="practicebeforeRemove" :responseFn="practiceUploadImage"
                    :action="VUE_APP_BASE_URL1" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.practice.files">
                  </BaseUploadFile>

                </el-form-item>
                <!-- <span>* 最少上传2张，最多上传9张</span> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>职称证</span><span></span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="12">
                <el-form-item label="上传图片：">
                  <BaseUploadFile :fileSize="6" :limit="9" :checkMore="true" :size="60" :isShowTip="false"
                    :responseFn="certificatePracticeResponse" :beforeRemove="certificatePracticebeforeRemove"
                    :action="VUE_APP_BASE_URL1" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.title.files">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>胸牌</span><span></span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24">
                <el-form-item label="上传图片：" required>
                  <BaseUploadFile :fileSize="6" message="* 最少上传1张，最多上传9张" :limit="9" :checkMore="true" :multiple="false"
                    :size="60" :isShowTip="false" :responseFn="certificateNameBadgeResponse"
                    :beforeRemove="certificateNameBadgebeforeRemove" :action="VUE_APP_BASE_URL1"
                    :data="{ path: 'dsicm-doctor' }" v-model="doctorCertificateSubmitDTO.nameBadge.files">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>其他相关资格证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="上传图片：">
                  <BaseUploadFile :limit="9" :fileSize="6" :checkMore="true" :size="60" :isShowTip="false"
                    :responseFn="certificateOtherUplod" :beforeRemove="certificateOtherbeforeRemove"
                    :action="VUE_APP_BASE_URL1" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.other.files">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>

            </el-row>
          </template>
          <template v-else>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>身份证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="国徽面：">
                  <el-image style="width: 280px; height: 138px;" :src="doctorCertificateSubmitDTO.idCard.back"
                    :z-index="2003" :preview-src-list="[doctorCertificateSubmitDTO.idCard.back]">
                  </el-image>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="头像面：">
                  <el-image style="width: 280px; height: 138px;" :src="doctorCertificateSubmitDTO.idCard.front"
                    :z-index="2003" :preview-src-list="[doctorCertificateSubmitDTO.idCard.front]">
                  </el-image>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>资格证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：">
                  {{doctorCertificateSubmitDTO.qualification.obtainDate?doctorCertificateSubmitDTO.qualification.obtainDate:'暂无数据'}}

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: ">
                  <span>{{doctorCertificateSubmitDTO.qualification.number?doctorCertificateSubmitDTO.qualification.number:"暂无数据"}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="tip-zhengshu">
                <el-form-item label="上传图片：">
                  <el-image style="width: 60px; height: 60px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.qualification.files" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.qualification.files">
                  </el-image>
                </el-form-item>

              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>执业证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：">
                  {{doctorCertificateSubmitDTO.practice.obtainDate?doctorCertificateSubmitDTO.practice.obtainDate:"暂无数据"}}

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: ">
                  <span>{{doctorCertificateSubmitDTO.practice.number?doctorCertificateSubmitDTO.practice.number:"暂无数据"}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="tip-zhengshu">
                <el-form-item label="上传图片：">
                  <el-image style="width: 60px; height: 60px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.practice.files" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.practice.files">
                  </el-image>
                  <span v-if="doctorCertificateSubmitDTO.practice.files.length==0">暂无数据</span>
                </el-form-item>

              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>职称证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="上传图片：">
                  <el-image style="width: 100px; height: 100px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.title.files" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.title.files">
                  </el-image>
                  <span v-if="doctorCertificateSubmitDTO.title.files.length==0">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" class="label-circle">
                <span>胸牌</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="上传图片：" required>
                  <el-image style="width: 100px; height: 100px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.nameBadge.files" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.nameBadge.files">
                  </el-image>
                  <span v-if="doctorCertificateSubmitDTO.nameBadge.files.length==0">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>其他相关资格证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="上传图片：">
                  <el-image style="width: 100px; height: 100px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.other.files" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.other.files">
                  </el-image>
                  <span v-if="doctorCertificateSubmitDTO.other.files.length==0">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </el-form>
        <span class="dialog-footer" v-if="newAdd&&active==2">
          <el-button class="dialog-btn" size="small" @click="closeaddCare3()">重置</el-button>
          <el-button class="dialog-btn" size="small" @click="PreviousStep()" plain>上一步</el-button>
          <el-button class="dialog-btn" size="small" type="primary" @click="submiAddCare3('addForm')">下一步</el-button>
        </span>
      </div>
      <template v-if="newAdd&&active==3">
        <span class="dialog-footer">
          <el-button class="dialog-btn" size="small" @click="PreviousStep()" plain>上一步</el-button>
          <el-button class="dialog-btn" size="small" type="primary" :disabled="loadingNew"
            @click="submiAddCare">提交审核</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog center width="900px" title="查看医护信息" v-if="dialogVisible1" :visible.sync="dialogVisible1" height="80vh"
      :close-on-click-modal="false" :destroy-on-close="true" @close="closeModule">

      <div class="top-tabs">
        <div :class="activeName1==1?'tabs-cliked':''" @click="handleTabClick(1)">
          <span>基本信息</span>
        </div>
        <div :class="activeName1==2?'tabs-cliked':''" @click="handleTabClick(2)">
          <span>归属团队</span>
        </div>
        <div :class="activeName1==3?'tabs-cliked':''" @click="handleTabClick(3)">
          <span>资质信息上传</span>
        </div>
        <div>

        </div>
      </div>
      <div v-if="activeName1 === 1" key="100">
        <div class="line-div">
          <span></span>
          <span>
            基本信息
          </span>
        </div>
        <template v-if="isEdit1">
          <el-form ref="addForm" @submit.native.prevent :model="information1" label-width="140px"
            :rules="isEdit1?rules:{}">
            <el-form-item label="医护照片: " required>
              <BaseUploadFile :fileSize="6" :isShowTip="false" :cropWidth="100" :cropHeight="100" :size="60"
                :action="VUE_APP_BASE_URL" :responseFn="handleMessageResponse2" :data="{ path: 'dsicm-doctor' }"
                v-model="upavater">

              </BaseUploadFile>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名: " prop="realName">
                  <el-input disabled v-model.trim="information1.realName" placeholder="请输入你的真实姓名">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号: " prop="mobile">
                  <el-input maxlength="11" disabled v-model="information1.mobile" placeholder="请输入11位有效数字 "></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>

              <el-col :span="12">
                <el-form-item label="医护类型: " disabled prop="doctorType">
                  <el-select disabled v-model="information1.doctorType" placeholder="请选择医护类型"
                    @change="selectDoctorType">
                    <el-option label="医生" :value="1"></el-option>
                    <el-option label="护士" :value="2"></el-option>
                    <!-- <el-option label="医技" :value="3"></el-option> -->
                    <el-option v-if="userPlatForm == 'platForm'" label="药师" :value="4"></el-option>
                    <el-option label="医辅" :value="6"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职称: " prop="titleId">
                  <el-select v-model="information1.titleId" @change="doctorTitleChange" placeholder="请选择职称">
                    <el-option v-for="(item, index) in doctorTitleList" :key="index" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="身份证号: " prop="idCard">
                  <el-input disabled v-model="information1.idCard" placeholder="请输入你的身份证号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="userPlatForm == 'platForm'">
                <el-form-item label="线下机构: " placeholder="请输入关键词搜索线下机构" prop="hospitalId" :rules="information1.doctorType==4?[{required:false}]:[{required:true,
								message: '请选择线下机构',
								trigger: 'change'}]">
                  <el-select :disabled="crolBtn" v-model="information1.hospitalId" clearable filterable
                    @change="hospitalChange">
                    <el-option v-for="(item, index) in hospitalList" :disabled="item.disabled" :key="index"
                      :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="线下科室: " prop="departmentId" :rules="information1.doctorType==4?[{required:false}]:[{required:true,
								message: '请选择线下科室',
								trigger: 'change'}]">
                  <el-cascader ref="Mycascader" @change="departmentChange()" filterable placeholder="请输入关键词搜索线下科室"
                    v-model="information1.departmentId" :options="departmentList" clearable
                    :props="SetKesDept"></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="专业擅长: " prop="professional" v-if="information1.doctorType==1">
              <el-input v-model="information1.professional" placeholder="请输入专业擅长" type="textarea"
                resize="none"></el-input>
            </el-form-item>
            <el-form-item label="医生介绍: " prop="note" v-if="information1.doctorType==1">
              <el-input resize="none" type="textarea" placeholder="请输入医生介绍" v-model="information1.note">
              </el-input>
            </el-form-item>
            <el-form-item label="护士上门服务: " prop="provideNursingService" v-if="information1.doctorType == 2">
              <el-radio-group v-model="information1.provideNursingService" @change="redioChange()">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="护士上门服务地理范围(KM): " class="lH20" prop="serviceScopeKm"
              v-if="information1.doctorType == 2&&information1.provideNursingService">
              <div style="display:flex">
                <el-input v-model.trim="information1.serviceScopeKm" @input="inputNumber"
                  placeholder="请输入数值"></el-input>
                <div style="color:red;width:300px;font-size:12px">（以归属医院地址为中心点）</div>
              </div>

            </el-form-item>

          </el-form>

        </template>
        <template v-else>
          <el-form @submit.native.prevent :model="information1" label-width="100px">
            <el-form-item label="医护照片: ">
              <el-image style="width: 60px; height: 60px;margin-right:10px" :src="upavater" :z-index="2003">
                <div slot="error" class="image-slot">
                  <img src="@/assets/images/noImage.svg">
                </div>
              </el-image>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名: " prop="realName">
                  <span>{{information1.realName}}</span>

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号: " prop="mobile">
                  <span>{{information1.mobile}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="医护类型: " prop="doctorType">
                  <span>{{information1.doctorType==1?'医生':information1.doctorType==2?'护士':information1.doctorType==6?'医辅':'药师'}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职称: " prop="titleName">
                  <span>{{information1.titleName?information1.titleName:'暂无数据'}}</span>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="身份证号: " prop="idCard">
                  <span>{{information1.idCard}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="userPlatForm == 'platForm'">
                <el-form-item label="线下机构: " placeholder="请选择线下机构" prop="hospitalName">
                  <span>{{information1.hospitalName ? information1.hospitalName : '暂无数据'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="线下科室: " prop="departmentName">
                  <span>{{information1.departmentName?information1.departmentName:'暂无数据'}}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="专业擅长: " prop="professional" v-if="information1.doctorType==1">
              <span>{{information1.professional ? information1.professional : '暂无数据'}}</span>
            </el-form-item>
            <el-form-item label="医生介绍: " prop="note" v-if="information1.doctorType==1">
              <span>{{information1.note?information1.note : "暂无数据"}}</span>
            </el-form-item>
            <el-form-item label="护士上门服务: " v-if="information1.doctorType == 2" prop="provideNursingService">
              <span>{{information1.provideNursingService?'是':'否'}}</span>
            </el-form-item>
            <el-form-item label="护士上门服务地理范围(KM): " class="lH20" prop="serviceScopeKm"
              v-if="information1.doctorType == 2&&information1.provideNursingService">
              <span>{{information1.serviceScopeKm ? information1.serviceScopeKm : '暂无数据'}}</span>
            </el-form-item>
          </el-form>
        </template>
        <span class="dialog-footer" v-if="!isEdit1">
          <el-button class="dialog-btn" size="small" type="primary" @click="isEdit1=true;crolBtn=true">去编辑</el-button>
        </span>
        <span class="dialog-footer" v-if="isEdit1">
          <el-button class="dialog-btn" size="small" @click="closeaddCare4()">重置</el-button>
          <el-button class="dialog-btn" size="small" type="primary" @click="submiAddCare4('addForm')">保存</el-button>
        </span>
      </div>
      <div v-if="activeName1 == 2" :key="200">
        <div class="line-div">
          <span></span>
          <span>
            归属团队
          </span>
        </div>
        <template>
          <div class="team-item" v-if="joinedTeamList.length==0"
            style="font-weight: 600;font-size: 12px;line-height: 20px;">暂无团队</div>
          <div class="team-item" v-for="items in joinedTeamList" :key="items.id" v-show="items.leader">
            <h3 style="font-weight: 600;color: #1A7BFC;line-height: 20px;">独立团队</h3>
            <ul>
              <li>
                <label>团队名称：</label>
                <p>{{items.teamName?items.teamName:'暂无数据'}}</p>
              </li>
              <li v-if="userPlatForm == 'platForm'">
                <label>线下机构：</label>
                <p>{{items.teamHospitalName?items.teamHospitalName:'暂无数据'}}</p>
              </li>
              <li>
                <label>线下科室：</label>
                <p>{{items.teamDepartmentName?items.teamDepartmentName:'暂无数据'}}</p>
              </li>
              <li>
                <label>个案组：</label>
                <p>{{items.caseMgrGroupName ? items.caseMgrGroupName : '暂无数据'}}</p>
              </li>
            </ul>
          </div>
          <div class="team-item" v-for="(items,index) in joinedTeamList" :key="index+1" v-show="!items.leader">
            <h3 style="font-weight: 600;color: #1A7BFC;line-height: 20px;">归属团队</h3>
            <ul>
              <li>
                <label>团队名称：</label>
                <p>{{items.teamName?items.teamName:'暂无数据'}}</p>
              </li>
              <li v-if="userPlatForm == 'platForm'">
                <label>线下机构：</label>
                <p>{{items.teamHospitalName?items.teamHospitalName:'暂无数据'}}</p>
              </li>
              <li>
                <label>线下科室：</label>
                <p>{{ items.teamDepartmentName ? items.teamDepartmentName : '暂无数据' }}</p>
              </li>
              <li>
                <label>个案组：</label>
                <p>{{ items.caseMgrGroupName ? items.caseMgrGroupName:'暂无数据'}}</p>
              </li>
            </ul>
          </div>
        </template>

      </div>
      <div v-if="activeName1 == 3" key="300" class="info-upload">
        <div class="line-div">
          <span></span>
          <span>
            资质信息上传
          </span>
        </div>
        <el-form label-width="150px" ref="infoUpload" :rules="{}" :model="doctorCertificateSubmitDTO"
          @submit.native.prevent>
          <template v-if="isEdit3">
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>身份证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;">
              <el-col :span="12">
                <el-form-item label="国徽面：" required>
                  <BaseUploadFile :multiple="false" :fileSize="6" :isShowTip="false" :cropWidth="279" :cropHeight="138"
                    :size="279" :height="138" :action="VUE_APP_BASE_URL1" :beforeRemove="handleMessage3beforeRemove"
                    :responseFn="handleMessageResponse3" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.idCard.back">

                  </BaseUploadFile>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="头像面：" required>
                  <BaseUploadFile :multiple="false" :fileSize="6" :isShowTip="false" :cropWidth="100" :cropHeight="100"
                    :size="279" :height="138" :action="VUE_APP_BASE_URL1" :beforeRemove="handleMessage4beforeRemove"
                    :responseFn="handleMessageResponse4" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.idCard.front">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>资格证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：" required>
                  <el-date-picker style="width: 100%;" v-model="doctorCertificateSubmitDTO.qualification.obtainDate"
                    type="date" size="large" value-format="yyyy-MM-dd" placeholder="选择发证日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: " required>
                  <el-input maxlength="50" v-model="doctorCertificateSubmitDTO.qualification.number"
                    placeholder="请输入证书编号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24" class="tip-zhengshu">
                <el-form-item label="上传图片：">
                  <BaseUploadFile :fileSize="6" :size="60" :multiple="false" :limit="9" :isShowTip="false"
                    message="* 最少上传2张，最多上传9张" :checkMore="true" :beforeRemove="certificateQualificationbeforeRemove"
                    :responseFn="certificateQualificationResponse" :action="VUE_APP_BASE_URL1"
                    :data="{ path: 'dsicm-doctor' }" v-model="doctorCertificateSubmitDTO.qualification.files">
                  </BaseUploadFile>

                </el-form-item>
                <!-- <span>* 最少上传2张，最多上传9张</span> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>执业证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：" required>
                  <el-date-picker style="width: 100%;" v-model="doctorCertificateSubmitDTO.practice.obtainDate"
                    type="date" size="large" value-format="yyyy-MM-dd" placeholder="选择发证日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: " required>
                  <el-input maxlength="50" v-model="doctorCertificateSubmitDTO.practice.number"
                    placeholder="请输入证书编号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24" class="tip-zhengshu">
                <el-form-item label="上传图片：" required>
                  <BaseUploadFile :fileSize="6" :multiple="false" :size="60" :limit="9" :isShowTip="false"
                    message="* 最少上传2张，最多上传9张" :checkMore="true" :beforeRemove="practicebeforeRemove"
                    :responseFn="practiceUploadImage" :action="VUE_APP_BASE_URL1" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.practice.files">
                  </BaseUploadFile>

                </el-form-item>
                <!-- <span>* 最少上传2张，最多上传9张</span> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>职称证</span><span></span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <BaseUploadFile :fileSize="6" :checkMore="true" :limit="9" :multiple="false" :size="60"
                    :isShowTip="false" :responseFn="certificatePracticeResponse"
                    :beforeRemove="certificatePracticebeforeRemove" :action="VUE_APP_BASE_URL1"
                    :data="{ path: 'dsicm-doctor' }" v-model="doctorCertificateSubmitDTO.title.files">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" class="label-circle">

                <span>胸牌</span><span></span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 8px;">
              <el-col :span="24">
                <el-form-item label="上传图片：" required>
                  <BaseUploadFile :fileSize="6" message="* 最少上传1张，最多上传9张" :checkMore="true" :limit="9" :multiple="false"
                    :size="60" :isShowTip="false" :responseFn="certificateNameBadgeResponse"
                    :beforeRemove="certificateNameBadgebeforeRemove" :action="VUE_APP_BASE_URL1"
                    :data="{ path: 'dsicm-doctor' }" v-model="doctorCertificateSubmitDTO.nameBadge.files">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>其他相关资格证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <BaseUploadFile :fileSize="6" :limit="9" :checkMore="true" :multiple="false" :size="60"
                    :isShowTip="false" :responseFn="certificateOtherUplod" :beforeRemove="certificateOtherbeforeRemove"
                    :action="VUE_APP_BASE_URL1" :data="{ path: 'dsicm-doctor' }"
                    v-model="doctorCertificateSubmitDTO.other.files">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>

            </el-row>
          </template>
          <template v-else>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>身份证</span>
                <span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="国徽面：">
                  <el-image style="width: 280px; height: 138px;" :src="doctorCertificateSubmitDTO.idCard.watermarkBack"
                    :z-index="2003" :preview-src-list="[doctorCertificateSubmitDTO.idCard.watermarkBack]">
                  </el-image>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="头像面：">

                  <el-image style="width: 280px; height: 138px;" :src="doctorCertificateSubmitDTO.idCard.watermarkFront"
                    :z-index="2003" :preview-src-list="[doctorCertificateSubmitDTO.idCard.watermarkFront]">
                  </el-image>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>资格证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：">
                  {{doctorCertificateSubmitDTO.qualification.obtainDate?doctorCertificateSubmitDTO.qualification.obtainDate:'暂无数据'}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: ">
                  <span>{{doctorCertificateSubmitDTO.qualification.number?doctorCertificateSubmitDTO.qualification.number:'暂无数据'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 60px; height: 60px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.qualification.fileList" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.qualification.fileList">
                  </el-image>
                  <template
                    v-if="!doctorCertificateSubmitDTO.qualification.fileList||doctorCertificateSubmitDTO.qualification.fileList.length==0">暂无数据</template>
                </el-form-item>

              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">
                <span>执业证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发证日期：">
                  {{doctorCertificateSubmitDTO.practice.obtainDate?doctorCertificateSubmitDTO.practice.obtainDate:'暂无数据'}}

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书编号: ">
                  <span>{{doctorCertificateSubmitDTO.practice.number?doctorCertificateSubmitDTO.practice.number:'暂无数据'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 60px; height: 60px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.practice.fileList" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.practice.fileList">
                  </el-image>
                  <span
                    v-if="!doctorCertificateSubmitDTO.practice.fileList||doctorCertificateSubmitDTO.practice.fileList.length==0">暂无数据</span>
                </el-form-item>

              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>职称证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 100px; height: 100px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.title.fileList" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.title.fileList">
                  </el-image>
                  <span
                    v-if="!doctorCertificateSubmitDTO.title.fileList||doctorCertificateSubmitDTO.title.fileList.length==0">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" class="label-circle">

                <span>胸牌</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 100px; height: 100px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.nameBadge.fileList" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.nameBadge.fileList">
                  </el-image>
                  <span
                    v-if="!doctorCertificateSubmitDTO.nameBadge.fileList||doctorCertificateSubmitDTO.nameBadge.fileList.length==0">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="label-circle">

                <span>其他相关资格证</span><span></span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传图片：">
                  <el-image style="width: 100px; height: 100px;margin-right:10px"
                    v-for="(item,index) in doctorCertificateSubmitDTO.other.fileList" :key="index" :src="item"
                    :z-index="2003" :preview-src-list="doctorCertificateSubmitDTO.other.fileList">
                  </el-image>
                  <span
                    v-if="!doctorCertificateSubmitDTO.other.fileList||doctorCertificateSubmitDTO.other.fileList.length==0">暂无数据</span>
                </el-form-item>
              </el-col>

            </el-row>
          </template>
        </el-form>
        <span class="dialog-footer" v-if="!isEdit3">
          <el-button class="dialog-btn" size="small" type="primary" @click="isEdit3=true">去编辑</el-button>
        </span>
        <span class="dialog-footer" v-if="isEdit3">
          <el-button class="dialog-btn" size="small" @click="closeaddCare5()">重置</el-button>
          <el-button class="dialog-btn" size="small" type="primary" @click="submiAddCare5('addForm')">保存</el-button>
        </span>
      </div>

    </el-dialog>
    <!-- </el-dialog> -->
    <ServiceAllocation :centerDialogObj="centerDialogObj" ref="serviceAllocation"></ServiceAllocation>
  </el-container>
</template>

<script>
import axios from "axios";
import local from "@/utils/local.js";
import Basequery from "./components/query";
import {
  api_doctor_team,
  associateList,
  distribute
} from "@/api/Patientmanagement.js";
import {
  hospital,
  openeDpartment,
  treeList,
  doctorTeam
} from "@/api/doctorTeam.js";
import {
  submitCertificate,
  getPlatformList,
  getPlatformDepartmentList,
  getPlatformOpenDepartmentList,
  addDoctorPlatform,
  deleteDoctorPlatform,
  getListByDoctorId,
  getDoctorNursingDetail,
  doctorNurseCreate,
  checkIdCardNumber,
  getHaveNursingService,
  doctor_title,
  getHospitalList
} from "./api";
import TableColumnConfig from "./conmon/careTanleConfig";
import {
  api_hospital,
  api_department,
  api_doctor_title,
  setAsStar,
  setHospitalAsStar
} from "./api/medicalinfo";
import {
  getDoctor,
  updetaDoctor,
  api_doctor_search,
  renmoveDoctor,
  offDisable,
  offEnable
} from "@/api/docinfo";
import ServiceAllocation from "./components/ServiceAllocation";

export default {
  mixins: [TableColumnConfig],
  components: {
    Basequery,
    ServiceAllocation
  },
  data() {
    // 手机号验证
    var validatorPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    // 身份证验证
    var validatorCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("身份证号不能为空"));
      } else if (
        !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          value
        )
      ) {
        callback(new Error("身份证号格式错误"));
      } else {
        callback();
      }
    };
    return {
      breadList: [{ name: "机构组织" }, { name: "医护信息" }],
      rightEventList: [{ eventName: "新增医护", eventValue: 1 }],
      searchList: [
        {
          label: "医护类型",
          value: 1,
          paramName: "doctorType",
          inputType: "select",
          optionData: [
            { label: "医生", value: 1 },
            { label: "护士", value: 2 },
            { label: "医辅", value: 6 },
            { label: "药师", value: 4 } //平台有，机构无
          ]
        },
        {
          label: "姓名",
          value: 2,
          paramName: "doctorName",
          inputType: "input",
          maxLength: 5
        },
        {
          label: "性别",
          value: 3,
          paramName: "gender",
          inputType: "select",
          optionData: [
            { label: "男", value: 1 },
            { label: "女", value: 2 }
          ]
        },
        {
          label: "手机号",
          value: 4,
          paramName: "phone",
          inputType: "input"
        },
        {
          label: "线下机构",
          value: 5,
          paramName: "hospitalId",
          inputType: "hospital",
          optionData: []
        },
        {
          label: "归属团队",
          value: 6,
          paramName: "doctorTeamName",
          inputType: "input"
        },
        {
          label: "开通问诊",
          value: 7,
          paramName: "openInquiry",
          inputType: "select",
          optionData: [
            { label: "是", value: 1 },
            { label: "否", value: 0 }
          ]
        },
        {
          label: "提交方式",
          value: 8,
          paramName: "sourceType",
          inputType: "select",
          optionData: [
            { label: "后台新增", value: 1 },
            { label: "app注册", value: 2 }
          ]
        },
        {
          label: "审核状态",
          value: 9,
          paramName: "certificateStatus",
          inputType: "select",
          optionData: [
            { label: "已提交", value: 2 },
            { label: "通过", value: 3 },
            { label: "驳回", value: 4 },
            { label: "待认证", value: 1 }
          ]
        },
        {
          label: "状态",
          value: 10,
          paramName: "disabled",
          inputType: "select",
          optionData: [
            { label: "启用", value: "false" },
            { label: "停用", value: "true" }
          ]
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      isEdit1: false,
      isEdit2: false,
      isEdit3: false,
      newSelectTteam: "",
      isMdt: false,
      joinedTeamList: [],
      doctorTeamList: [], //其他团队
      platformOptions: [], //归属平台
      departmentList: [], //归属科室
      departmentList1: [], //归属科室
      caseMgrGroupList: [], //个案组列表
      dialogVisible1: false,
      crolBtn: false,
      doctorCertificateSubmitDTO: {
        idCard: {
          back: "",
          front: "",
          watermarkBack: "",
          watermarkFront: ""
        },
        other: {
          watermarkFiles: "",
          files: []
        },
        practice: {
          watermarkFiles: "",
          files: [],
          number: "",
          obtainDate: ""
        },
        qualification: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: ""
        },
        title: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: ""
        },
        nameBadge: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: ""
        }
      },
      doctorTeam: {
        type: "0",
        id: "",
        doctorTeamName: "",
        name: "",
        departmentId: "",
        departmentName: "",
        platformId: "",
        platformName: "",
        caseMgrGroupId: "",
        caseMgrGroupName: ""
      },
      active: 1,
      dialogVisible: false,
      activeName1: "1",
      newAdd: true,
      isEdit: true,
      centerDialogObj: {}, //上门服务分配数据
      isAllChecked: false,
      platformList: {
        //互医平台医院列表
        hospitalList: [],
        departmentList: [],
        tableData: [] //互医平台table数据
      },
      addplatform: {
        doctorId: "", //医生id
        platformNameId: "", //平台id
        platformDepartmentId: "" //科室id
      },
      formInline: {
        keyword: "", //模糊查询
        time: "", //时间
        hospitalId: "", //所属医院
        departmentId: "", //业务科室
        doctorType: "",
        disabledList: [],
        disabled: "",
        keywordSearchField:
          local.get("userPlatForm") == "platForm"
            ? ["hospital"]
            : ["hospital", "openDepartment"]
      },
      formInlineCopy: {
        // doctorType: [], //医护类型
        disabledList: [], //账号启用：
        openInternetInquiryList: [], //互医服务：
        appointmentList: [], //开放预约
        openWholeTreatmentList: [], //全病程服务：
        recommendList: [], //置顶推荐：
        certificateStatus: [], //资质审核：
        archivedList: [], //ca签名
        prescriptionStatus: [], //处方权
        prescriptionApprovalStatus: [], //审方权
        starList: [] //明星
      },
      rulesCopy: {
        //修改医护信息限制
        phone: [
          {
            required: true,
            validator: validatorPhone,
            trigger: "blur"
          }
        ],
        professional: [
          {
            required: true,
            message: "请输入专业擅长",
            trigger: "blur"
          },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur"
          }
        ],
        introduction: [
          {
            required: true,
            message: "请输入医生介绍",
            trigger: "blur"
          },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur"
          }
        ]
      },
      rules: {
        realName: [
          {
            required: true,
            message: "请输入医生名称",
            trigger: "blur"
          },
          {
            min: 2,
            max: 5,
            message: "长度在 2 到 5 个字符",
            trigger: "blur"
          }
        ],
        mobile: [
          {
            required: true,
            validator: validatorPhone,
            trigger: "blur"
          }
        ],
        idCard: [
          {
            required: true,
            validator: validatorCard,
            trigger: "blur"
          }
        ],

        doctorType: [
          {
            required: true,
            message: "请选择医护类型",
            trigger: "change"
          }
        ],
        titleId: [
          {
            required: true,
            message: "请选择职称",
            trigger: "change"
          }
        ],
        professional: [
          {
            required: true,
            message: "请输入专业擅长",
            trigger: "blur"
          },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur"
          }
        ],
        note: [
          {
            required: true,
            message: "请输入医生介绍",
            trigger: "blur"
          },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur"
          }
        ],
        serviceScopeKm: [
          {
            required: true,
            message: "请输入服务范围",
            trigger: "blur"
          }
        ],
        provideNursingService: [
          {
            required: true,
            message: "请选择是否提供上门服务",
            trigger: "blur"
          }
        ]
      },
      //	身份证
      idCard: {
        back: "",
        front: ""
      },
      other: {
        //其他证
        files: ""
      },
      practice: {
        //执业证
        files: "",
        number: "",
        obtainDate: ""
      },
      practiceRules: {
        obtainDate: [
          {
            required: true,
            message: "请选择发证日期",
            trigger: "blur"
          }
        ],
        number: [
          {
            required: true,
            message: "请填写证书编号",
            trigger: "blur"
          }
        ]
      },
      qualification: {
        //资格证
        files: "",
        number: "",
        obtainDate: ""
      },
      qualificationRules: {
        obtainDate: [
          {
            required: true,
            message: "请选择发证日期",
            trigger: "blur"
          }
        ],
        number: [
          {
            required: true,
            message: "请填写证书编号",
            trigger: "blur"
          }
        ]
      },
      title: {
        //职称证
        files: []
      },
      imgBaseURLArray: {
        idCard: {
          back: "",
          front: ""
        },
        other: {
          files: ""
        },
        practice: {
          files: ""
        },
        qualification: {
          files: ""
        },
        title: {
          files: ""
        }
      },
      imgBaseURLArrayCopy: {},
      isModifyType: true,
      showImgList: [],
      editBtn: false, //是否可以修改状态
      top: "8vh",
      VUE_APP_BASE_URL: "",
      VUE_APP_BASE_URL1: "",
      input: "", //搜索组件
      checked: true, //全选按钮
      tableData: [], //列表数据
      drawer: false, //详情弹窗
      activeName: "details",
      addcare: false, //新增医护弹窗
      upavater: "", //需要上传的图片路径
      backCard: {
        name: "",
        bankName: "",
        cardNo: ""
      },
      showView: false, //是否展示银行卡信息
      totalPage: 0, // 总条数
      information: {
        name: "", //姓名
        idCardNumber: "", //证件 号码
        phone: "", //手机号码
        doctorType: "", //医生类型
        titleId: "", //职称
        idCardType: "", //证件类型1身份证2军官证
        hospitalId: "", //实体医院id
        departmentId: "", //实体科室id
        birthday: "", //出生日期
        gender: "1", //性别 1男2女0未知
        disabled: "false", //是否禁用 1是 0 否
        photoUrl: "", //医生照片
        professional: "", //专业擅长
        introduction: "", //医生个人介绍
        serviceScopeKm: "", //服务上门km
        provideNursingService: true
      },
      informationCopy: {}, //string类型对比information数据，不同按钮开启，否则禁用
      //新增医护占位
      information1: {
        realName: "", //姓名
        mobile: "", //手机号码
        idCard: "", //证件 号码
        // gender: '', //性别 1男2女0未知
        // birthday: '', //出生日期
        avatar: "", //医生照片
        photoUrlCopy: "", //用来展示图片
        note: "", //介绍
        departmentId: "", //科室ID
        departmentName: "",
        doctorType: "", //医护类型1.医生,2.护士,3.医技,4.药师6医辅
        hospitalId: "", //医院ID
        hospitalName: "",
        professional: "", //专业擅长
        titleId: "", //职称ID
        titleName: "",
        serviceScopeKm: "", //上门服务km
        provideNursingService: true
      },
      accountobj: {}, //新增医护提交
      infoobj: {}, //新增医护提交
      doctorobj: {}, //新增医护提交
      hospitalList: [], //接口返回医院数组
      hospitalObj: {},
      // departmentList: [], //接口返回科室数组
      SetKesDept: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false
      }, //设置联级选择器绑定的值
      doctorTitleList: [], //接口返回职称数据
      professional: {}, //专业资质信息,
      certificateIdCard: {
        //身份证
        address: "", //所在地址
        back: "", //背面url
        backCopy: "",
        front: "", //正面url
        frontCopy: "",
        createUserId: "", //创建用户id
        status: "", //审核状态
        validity: "", //有效期
        idCardNumber: "", //身份证号码,
        id: "" //
      },
      medicalDetails: {
        certificateIdCard: {}, //身份证
        certificateQualification: {}, //资格证
        certificatePractice: {}, //执业证
        certificateTitle: {}, //职称证
        certificateOther: {}, //相关资格证
        bankCardList: []
      }, //医护详情
      setKesDept: {
        value: "id",
        label: "name",
        children: "children",
        disabled: "value",
        emitPath: false
      },
      loadingNew: false,
      userPlatForm: local.get("userPlatForm"), //平台：platForm 机构：organization local.get('userPlatForm')
      orgName: local.get("orgName") ? local.get("orgName") : "",
      flagId: "",
      haveService: false,
      hospitalId: ""
    };
  },
  created() {
    this.info();
    this.getEntityHospital(); //获取实体医院列表
    this.getDoctorTitle(); //获取职称段位
    this.getPlatformListInit();
    if (this.userPlatForm == "organization") {
      this.apiDoctorTeamSearchinit(local.get("hospitalId"));
      this.hospitalId = local.get("hospitalId");
      this.searchList[0].optionData.pop();
      this.searchList.splice(4, 1);
    } else {
      this.apiDoctorTeamSearchinit();
    }
    this.getPlatformListHandel();
    this.VUE_APP_BASE_URL = "/api/dsicm-contact-platform/feign/file/upload";
    this.VUE_APP_BASE_URL1 =
      "/api/dsicm-contact-platform/feign/file/uploadWatermark";
  },
  computed: {
    //互医科室添加限制 有平台id并且有科室ID可以开启，isEdit权重最高
    isEditBtn() {
      if (this.isEdit) return true;
      else if (
        this.addplatform.platformNameId &&
        this.addplatform.platformDepartmentId
      )
        return false;
      else return true;
    },
    //保存按钮的体现 当新数据和旧数据不同 开启保存按钮，否则禁用
    isaddEditBtn() {
      let isx = true;
      Object.keys(this.imgBaseURLArrayCopy).forEach(item => {
        Object.keys(this.imgBaseURLArrayCopy[item]).forEach(sub => {
          if (
            this.imgBaseURLArray[item][sub] !=
            this.imgBaseURLArrayCopy[item][sub]
          )
            isx = false;
        });
      });

      if (
        !this.medicalDetails.certificateQualification ||
        !this.medicalDetails.certificatePractice
      ) {
        return false;
      }
      if (
        this.qualification.number !==
          this.medicalDetails.certificateQualification.number ||
        this.qualification.obtainDate !==
          this.medicalDetails.certificateQualification.obtainDate ||
        this.practice.number !==
          this.medicalDetails.certificatePractice.number ||
        this.practice.obtainDate !==
          this.medicalDetails.certificatePractice.obtainDate
      ) {
        return false;
      }

      let information = Object.values(this.information);
      information = information.toString().replace(/,/g, "");
      if (this.informationCopy == information && isx) return true;
      else false;
    },
    //选择医护类型的时候当医护类型为药师，归属医院和归属科室消失，
    selsectPharmacist() {
      if (this.information1.doctorType == 4) {
        this.information1.hospitalId = "";
        this.information1.departmentId = "";
        return false;
      } else {
        return true;
      }
    }
  },

  methods: {
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      if (this.searchParams.hospitalName) {
        delete this.searchParams.hospitalName;
      }
      this.info();
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.newAddDocPeopel();
      }
    },
    closeModule() {
      this.isMdt = false;
      this.information1.realName = ""; //姓名
      this.information1.mobile = ""; //手机号码
      (this.information1.idCard = ""), //证件 号码
        (this.doctorTitleList = []);
      this.upavater = ""; //医生照片
      this.information1.photoUrlCopy = ""; //用来展示图片
      (this.information1.note = ""), //介绍
        (this.information1.departmentId = ""); //科室ID
      this.information1.departmentName = "";
      this.information1.doctorType = ""; //医护类型1.医生,2.护士,3.医技,4.药师
      this.information1.hospitalId = ""; //医院ID
      this.information1.hospitalName = "";
      this.information1.professional = ""; //专业擅长
      this.information1.titleId = ""; //职称ID
      this.information1.titleName = "";
      this.information1.serviceScopeKm = ""; //上门服务km
      this.information1.provideNursingService = true;
      this.closeaddCare1();

      this.newSelectTteam = "";
      this.doctorTeam.type = 0;
      this.doctorTeam.id = "";
      this.doctorTeam.doctorTeamName = "";
      this.doctorTeam.name = "";
      this.doctorTeam.departmentId = "";
      this.doctorTeam.departmentName = "";
      this.doctorTeam.platformId = "";
      this.doctorTeam.platformName = "";
      this.doctorTeam.caseMgrGroupId = "";
      this.doctorTeam.caseMgrGroupName = "";

      this.doctorCertificateSubmitDTO.idCard = {
        back: "",
        front: "",
        watermarkBack: "",
        watermarkFront: ""
      };
      this.doctorCertificateSubmitDTO.other = {
        files: [],
        fileList: [],
        watermarkFiles: ""
      };
      (this.doctorCertificateSubmitDTO.practice = {
        files: [],
        fileList: [],
        number: "",
        obtainDate: "",
        watermarkFiles: ""
      }),
        (this.doctorCertificateSubmitDTO.qualification = {
          files: [],
          fileList: [],
          obtainDate: "",
          number: "",
          watermarkFiles: ""
        }),
        (this.doctorCertificateSubmitDTO.title = {
          files: [],
          fileList: [],
          obtainDate: "",
          number: "",
          watermarkFiles: ""
        });
      this.doctorCertificateSubmitDTO.nameBadge = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: ""
      };
      this.active = 0;
      this.activeName1 = 1;
      // if(this.$refs['addForm']){
      this.$refs["addForm"].resetFields();
      // }
    },
    /**
     *
     * 关闭新增医护弹回调
     */
    closeaddCare5() {
      this.doctorCertificateSubmitDTO.idCard = {
        back: "",
        front: "",
        watermarkBack: "",
        watermarkFront: ""
      };
      (this.doctorCertificateSubmitDTO.other = {
        files: [],
        fileList: [],
        watermarkFiles: ""
      }),
        (this.doctorCertificateSubmitDTO.practice = {
          files: [],
          fileList: [],
          number: "",
          obtainDate: "",
          watermarkFiles: ""
        }),
        (this.doctorCertificateSubmitDTO.qualification = {
          files: [],
          fileList: [],
          obtainDate: "",
          number: "",
          watermarkFiles: ""
        });
      this.doctorCertificateSubmitDTO.title = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: ""
      };
      this.doctorCertificateSubmitDTO.nameBadge = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: ""
      };
    },
    closeaddCare4() {
      this.upavater = ""; //医生照片
      (this.information1.note = ""), //介绍
        (this.information1.departmentId = ""); //科室ID
      this.information1.professional = ""; //专业擅长
      // this.information1.hospitalId = ""; //医院ID
      // this.information1.hospitalName = '';
      this.information1.serviceScopeKm = ""; //上门服务km
      this.information1.provideNursingService = true;
    },
    closeaddCare1() {
      this.information1 = this.$options.data().information1;
      this.upavater = "";
      this.doctorTitleList = [];
    },
    redioChange() {
      this.information1.serviceScopeKm = "";
    },
    closeaddCare2() {
      if (this.information1.doctorType != 4) {
        this.newSelectTteam = "";
        this.doctorTeam.type = "";
        this.isMdt = false;
        this.doctorTeam.id = "";
        this.doctorTeam.doctorTeamName = "";
        this.doctorTeam.name = "";
        this.doctorTeam.departmentId = "";
        this.doctorTeam.departmentName = "";
        this.doctorTeam.platformId = "";
        this.doctorTeam.platformName = "";
        this.doctorTeam.caseMgrGroupName = "";
      }
    },
    closeaddCare3() {
      // if(this.information1.doctortype !== 4){
      this.doctorCertificateSubmitDTO.idCard = {
        back: "",
        front: "",
        watermarkBack: "",
        watermarkFront: ""
      };
      (this.doctorCertificateSubmitDTO.other = {
        files: [],
        watermarkFiles: ""
      }),
        (this.doctorCertificateSubmitDTO.practice = {
          files: [],
          number: "",
          obtainDate: "",
          watermarkFiles: ""
        }),
        (this.doctorCertificateSubmitDTO.qualification = {
          files: [],
          obtainDate: "",
          number: "",
          watermarkFiles: ""
        });
      this.doctorCertificateSubmitDTO.title = {
        files: [],
        obtainDate: "",
        number: "",
        watermarkFiles: ""
      };
      this.doctorCertificateSubmitDTO.nameBadge = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: ""
      };
    },
    caseMgrGroupChange(val) {
      this.doctorTeam.caseMgrGroupName = "";
      for (var i = 0; i < this.caseMgrGroupList.length; i++) {
        if (this.caseMgrGroupList[i].id == val) {
          this.doctorTeam.caseMgrGroupName = this.caseMgrGroupList[i].name;
        }
      }
    },
    doctorTeamChange(val) {
      this.doctorTeam.doctorTeamName = "";
      for (var i = 0; i < this.doctorTeamList.length; i++) {
        if (this.doctorTeamList[i].id == val) {
          this.doctorTeam.doctorTeamName = this.doctorTeamList[i].name;
        }
      }
    },
    departmentTeamChange() {
      this.doctorTeam.departmentName = "";
      this.$nextTick(() => {
        this.doctorTeam.departmentName = this.$refs[
          "Mycascader1"
        ].getCheckedNodes()[0].label;
      });
    },
    selectPlatformChange(options) {
      // return
      this.doctorTeam.platformName = "";
      for (var i = 0; i < this.platformOptions.length; i++) {
        if (this.platformOptions[i].id == options) {
          this.doctorTeam.platformName = this.platformOptions[i].name;
        }
      }
      // doctorTeam.platformId
      this.departmentList1 = []; //归属科室
      this.caseMgrGroupList = []; //个案组列表
      this.doctorTeam.departmentId = "";
      this.doctorTeam.caseMgrGroupId = "";
      this.getTreeList(options);
      getPlatformDepartmentList({
        platformId: options
      }).then(res => {
        if (res.code == 0) {
          this.departmentList1 = res.data;
        }
      });
    },
    apiDoctorTeamSearchinit(id) {
      api_doctor_team({
        disabled: false,
        hospitalId: id ? id : null
      }).then(res => {
        this.doctorTeamList = res.data;
      });
    },
    getPlatformListHandel() {
      // {disabled:false}
      getPlatformList({ disabled: false }).then(res => {
        if (res.code == 0) {
          this.platformOptions = res.data;
        }
      });
    },
    getTreeList(id) {
      treeList({
        type: 2,
        hospitalId: this.hospitalId
      }).then(res => {
        if (res.code == 0) {
          this.caseMgrGroupList = res.data;
        }
      });
    },
    radioChangeGrounp(e) {
      this.doctorTeam.name = "";
      this.doctorTeam.id = "";
      this.doctorTeam.platformId = "";
      this.doctorTeam.departmentId = "";
      this.doctorTeam.caseMgrGroupId = "";
      this.doctorTeam.openDepartmentId = "";
    },
    CanEdit() {
      this.isEdit = true;
    },
    newAddDocPeopel() {
      this.$router.push({ path: "/Organization/addMedicalinfo" });
      if (this.userPlatForm == "organization") {
        api_department({
          hospitalId: local.get("hospitalId")
        }).then(res => {
          if (res.code == 0) {
            this.departmentList = res.data;
          }
        });
      }
      this.crolBtn = false;
      this.active = 0;
      this.newAdd = true;
      this.activeName1 = 1;
      // this.dialogVisible = true;
    },
    PreviousStep() {
      this.flagId = this.information1.hospitalId;
      this.active -= 1;
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    setDoctor(data, num) {
      //机构端
      if (num == 1) {
        setHospitalAsStar({
          doctorId: data.id,
          value: data.recommendInHospital ? false : true
        }).then(res => {
          if (res.success) {
            this.$message.success("操作成功");
            this.info();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        setAsStar({
          doctorId: data.id,
          value: data.star ? false : true
        }).then(res => {
          if (res.success) {
            this.$message.success("操作成功");
            this.info();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    selectDoctorType(e) {
      this.getDoctorTitle(e);
      // if (e == 2) {
      this.information1.serviceScopeKm = "";
      (this.information1.note = ""), //介绍
        (this.information1.departmentId = ""); //科室ID
      this.information1.departmentName = ""; //科室ID
      this.information1.titleId = ""; //科室ID
      // this.information1.titleName = ""; //科室ID
      this.information1.professional = ""; //专业擅长
      this.information1.hospitalId = ""; //医院ID
      this.information1.hospitalName = "";
      this.information1.serviceScopeKm = ""; //上门服务km
      if (e == 2) {
        this.information1.provideNursingService = true;
      }
      // this.$refs['addForm'].clearValidate();
      this.closeaddCare2();
      this.closeaddCare3();
      // }
    },
    /**
     * @description: 上门分配
     * @param {*}
     * @return {*}
     */
    servesHandel(scope) {
      getDoctorNursingDetail({
        doctorId: scope.row.id
      }).then(res => {
        if (res.code == 0) {
          this.centerDialogObj = res.data;
          this.$refs.serviceAllocation.showModal();
        }
      });
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    inputChangeNumber() {
      if (this.information.serviceScopeKm.charAt(0) == ".") {
        this.information.serviceScopeKm = this.information.serviceScopeKm.substring(
          1
        );
      } else {
        this.information.serviceScopeKm = `${this.information.serviceScopeKm}`.replace(
          /^(\-)*(\d+)\.(\d).*$/,
          "$1$2.$3"
        );
      }
    },
    /**
     * @description: 选择医护类型 ，为护士的时候上门服务出现
     * @param {*}
     * @return {*}
     */
    doctorTypeChange(optios) {
      this.doctorType = optios;
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    inputNumber(e) {
      this.$nextTick(() => {
        this.information1.serviceScopeKm = e
          .replace(/[^\d.]/g, "")
          .replace(/\.{2,}/g, ".")
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".")
          .replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3")
          .replace(/^\./g, "");
      });
    },
    /**
     * @description: 根据医生ID查询平台列表
     * @param {*}
     * @return {*}
     */
    getListByDoctorIdInit() {
      getListByDoctorId(this.information1.id).then(res => {
        if (res.code == 0) {
          this.platformList.tableData = res.data;
        }
      });
    },

    /**
     * @description: 添加互医平台
     * @param {*}
     * @return {*}
     */
    addPlatformHandel() {
      this.addplatform.doctorId = this.medicalDetails.id;
      addDoctorPlatform(this.addplatform).then(res => {
        if (res.code == 0) {
          this.getListByDoctorIdInit();
        } else {
          this.$message({
            type: "error",
            message: res.message
          });
        }
      });
    },

    /**
     * @description: 删除互医平台
     * @param {*}
     * @return {*}
     */
    platformDelect(scope) {
      deleteDoctorPlatform(scope.row.id).then(res => {
        if (res.code == 0) {
          this.platformList.tableData.splice(scope.$index, 1);
        }
      });
    },

    /**
     * @description: 获取互医医院列表
     * @event:
     * @param {*}
     * @return {*}
     */
    getPlatformListInit() {
      getPlatformList({}).then(res => {
        if (res.code == 0) {
          this.platformList.hospitalList = res.data;
        }
      });
    },

    /**
     * @description: 获取相应互医医院下的科室
     * @event:
     * @param {*}
     * @return {*}
     */
    addselectOnChange(event) {
      this.addplatform.platformDepartmentId = "";
      this.platformList.departmentList = [];
      getPlatformDepartmentList({
        platformId: event
      }).then(res => {
        if (res.code == 0) {
          this.platformList.departmentList = res.data;
        }
      });
    },

    /**
     * @description: 全选筛选条件
     * @event:
     * @param {*}
     * @return {*}
     */
    selectAll(e) {
      if (e) {
        this.buttonList.forEach(item => {
          Object.keys(this.formInlineCopy).map(key => {
            if (item.module == key) {
              this.formInlineCopy[key].push(...item.list.map(sub => sub.value));
            }
          });
        });
      } else {
        this.formInlineCopy = this.$options.data().formInlineCopy;
      }
    },

    /**
     * @description: 判断是否全选
     * @event:
     * @param {*}
     * @return {*}
     */
    equal(e) {
      if (e) this.isAllChecked = true;
      else this.isAllChecked = false;
    },
    /**
     * @description: 提交查询条件
     * @event:
     * @param {*}
     * @return {*}
     */
    formData(e) {
      let paramData = JSON.parse(JSON.stringify(e));
      if (Array.isArray(e.departmentId)) {
        paramData.departmentId =
          paramData.departmentId[paramData.departmentId.length - 1];
      }
      if (Array.isArray(e.time) && e.time.length > 1) {
        paramData.updateStartTime = e.time[0];
        paramData.updateEndTime = this.$machiningTime(e.time[1]);
        delete paramData.time;
      } else {
        paramData.updateStartTime = "";
        paramData.updateEndTime = "";
      }
      this.searchParams.current = 1;
      this.searchParams.size = 10;
      this.searchParams = Object.assign({}, this.searchParams, paramData);
      api_doctor_search(this.searchParams).then(res => {
        if (res.code == 0) {
          this.totalPage = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },

    /**
     * @description: 提交按钮 涉及到医护信息和专业资质中信息，先验证这两个模块中的信息是否满足条件，当所有模块验证通过后才开始调取接口，然后第一个接口成功后依次递增下面的模块接口
     *               根据certificateIdCard来判断用户是否是第一次提交，第一次提交则不显示确认弹窗，否则显示
     * //TODO       一个保存按钮执行多个接口提交操作，切换到第二个tab栏提交第一个tab栏中的数据，出现报错问题 应该切换到错误到tab栏中，并且滚动到当前错误到位置
     *              判断这两个接口模块是否修改 ，修改后提交按钮才可以使用，否则禁用
     * @param {*} formName
     * @return {*}
     */
    submitAdd(formName) {
      let valRes;
      this.$refs.qualificationRef.validate(val => {
        valRes = val;
      });
      let valRes1;
      this.$refs.practiceRef.validate(val => {
        valRes1 = val;
      });
      if (!valRes1 || !valRes) {
        return;
      }

      if (!this.information.titleId) {
        this.$message.error("请选择职称");
        return;
      }
      if (this.information.doctorType != 4 && !this.information.hospitalId) {
        this.$message.error("请选择实体平台");
        return;
      }
      if (this.information.doctorType != 4 && !this.information.departmentId) {
        this.$message.error("请选择实体科室");
        return;
      }

      if (!this.information.professional) {
        this.$message.error("请输入专业擅长");
        return;
      }
      if (!this.information.introduction) {
        this.$message.error("请输入医生介绍");
        return;
      }
      if (!this.information.photoUrl || this.information.photoUrl == null) {
        this.$message.error("请上传医生照片");
        this.activeName = "details";
        return false;
      }
      if (this.medicalDetails.certificateIdCard) {
        this.$confirm("重新提交将再次审核, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$refs[formName].validate(valid => {
            if (valid) {
              if (!this.information.photoUrl) {
                this.$message.error("请上传医生照片");
                this.activeName = "details";
                return false;
              }
              if (!this.idCard.back) {
                this.$message.error("请上传人面像");
                this.activeName = "qualifications";
                return;
              }
              if (!this.idCard.front) {
                this.$message.error("请上传国徽面");
                this.activeName = "qualifications";
                return;
              }
              if (!this.qualification.files.length) {
                this.$message.error("请上传资格证");
                this.activeName = "qualifications";
                return;
              }
              if (
                this.information.doctorType == 1 &&
                !this.practice.files.length
              ) {
                this.$message.error("请上传执业证");
                this.activeName = "qualifications";
                return;
              }
              // this.information.photoUrl = this.information.photoUrl.substring(process.env.VUE_APP_OSS_URL.length);
              let photoUrlA = JSON.parse(
                JSON.stringify(this.information.photoUrl)
              );

              photoUrlA = photoUrlA.substring(
                process.env.VUE_APP_OSS_URL.length
              );
              const copyInfo = JSON.parse(JSON.stringify(this.information));
              Object.keys(copyInfo).map(item => {
                if (this.information[item] == "null") {
                  copyInfo[item] = "";
                }
              });
              // return
              updetaDoctor({
                ...copyInfo,
                photoUrl: photoUrlA,
                id: this.medicalDetails.id
              }).then(res => {
                if (res.code === 0) {
                  this.submitCartList();
                } else {
                  this.$message({
                    type: "error",
                    message: `医护信息模块${res.message}`
                  });
                }
              });
            } else {
              this.activeName = "details";
            }
          });
        });
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (!this.information.photoUrl) {
              this.$message.error("请上传医生照片");
              this.activeName = "details";
              return false;
            }
            if (!this.idCard.back) {
              this.$message.error("请上传人面像");
              this.activeName = "qualifications";
              return false;
            }
            if (!this.idCard.front) {
              this.$message.error("请上传国徽面");
              this.activeName = "qualifications";
              return false;
            }
            if (!this.qualification.files.length) {
              this.$message.error("请上传资格证");
              this.activeName = "qualifications";
              return false;
            }
            if (
              this.information.doctorType == 1 &&
              !this.practice.files.length
            ) {
              this.$message.error("请上传执业证");
              this.activeName = "qualifications";
              return false;
            }
            // this.information.photoUrl = this.information.photoUrl.substring(process.env.VUE_APP_OSS_URL.length);
            let photoUrlA = JSON.parse(
              JSON.stringify(this.information.photoUrl)
            );

            photoUrlA = photoUrlA.substring(process.env.VUE_APP_OSS_URL.length);
            updetaDoctor({
              ...this.information,
              photoUrl: photoUrlA,
              id: this.medicalDetails.id
            }).then(res => {
              if (res.code === 0) {
                this.submitCartList();
              } else {
                this.$message({
                  type: "error",
                  message: `医护信息模块${res.message}`
                });
              }
            });
          } else {
            this.activeName = "details";
          }
        });
      }
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    add() {
      let idCartCopy = {};
      let a = JSON.parse(JSON.stringify(this.idCard));
      Object.keys(this.idCard).forEach(item => {
        idCartCopy[item] = a[item].substring(
          process.env.VUE_APP_OSS_URL.length
        );
      });
      const machiningFiles = filesName => {
        if (Array.isArray(filesName)) {
          return filesName
            .map(sub => sub.substring(process.env.VUE_APP_OSS_URL.length))
            .join();
        } else {
          return filesName
            .split(",")
            .map(sub => sub.substring(process.env.VUE_APP_OSS_URL.length))
            .join();
        }
      };
      this.imgBaseURLArrayCopy = {
        idCard: idCartCopy,
        qualification: {
          files: machiningFiles(this.qualification.files)
        },
        practice: {
          files: machiningFiles(this.practice.files)
        },
        title: {
          files: machiningFiles(this.title.files)
        },
        other: {
          files: machiningFiles(this.other.files)
        }
      };
    },
    /**
     * @description: 判断用户是否修改，修改后才允许提交 目前偷懒只要上传或者删除后都可以提交，不严谨思路 转换字符串然后对比字符串
     * @event:
     * @param {*}
     * @return {*}
     */
    submitCartList() {
      //TODO 此处可以优化
      const imgLists = {
        idCard: this.idCard,
        other: {
          files: this.other.files || []
        },
        practice: {
          files: this.practice.files || []
        },
        qualification: {
          files: this.qualification.files || []
        },
        title: {
          files: this.title.files || []
        }
      };
      const img = {
        idCard: {
          back: "",
          front: ""
        },
        other: {
          files: []
        },
        practice: {
          files: [],
          number: this.practice.number,
          obtainDate: this.practice.obtainDate ? this.practice.obtainDate : ""
        },
        qualification: {
          files: [],
          number: this.qualification.number,
          obtainDate: this.qualification.obtainDate
            ? this.qualification.obtainDate
            : ""
        },
        title: {
          files: []
        }
      };
      Object.keys(img).forEach(item => {
        if (item == "idCard") {
          Object.keys(imgLists[item]).forEach(sub => {
            img[item][sub] = imgLists[item][sub].substring(
              process.env.VUE_APP_OSS_URL.length
            );
          });
        } else {
          // debugger
          img[item].files = imgLists[item].files
            .map(item => item.substring(process.env.VUE_APP_OSS_URL.length))
            .join(",");
        }
      });
      submitCertificate({
        doctorId: this.medicalDetails.id,
        idCard: this.idCard,
        ...img
      }).then(res => {
        if (res.code == 0) {
          this.$message.success(`提交成功`);
          this.info();
          setTimeout(() => {
            this.drawer = false;
          }, 1000);
        } else {
          this.$message({
            type: "error",
            message: `专业资质模块${res.message}`
          });
        }
      });
    },
    /**
     * @description: 身份证正反面上传
     * @event:
     * @param {*} response
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     */
    handleIdCardFrontResponse1(response, file, fileList) {
      if (response.code == 0) {
        //TODO 必须在return 之后进行执行
        setTimeout(() => {
          this.add();
        }, 100);
        return (this.idCard.back = `${process.env.VUE_APP_OSS_URL}${response.data}`);
      }
    },
    handleIdCardBackResponse2(response) {
      if (response.code == 0) {
        setTimeout(() => {
          this.add();
        }, 100);
        return (this.idCard.front = `${process.env.VUE_APP_OSS_URL}${response.data}`);
      }
    },

    /**
     * @description: 上传资格证图片
     * @event:
     * @param {*}
     * @return {*}
     */
    certificateQualificationResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        let a = `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`;
        if (
          this.doctorCertificateSubmitDTO.qualification.watermarkFiles == ""
        ) {
          this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.qualification.watermarkFiles = arr.join(
            ","
          );
        }

        return this.doctorCertificateSubmitDTO.qualification.files.push(a);
      }
    },
    certificateQualificationbeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(
        ","
      );
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.qualification.watermarkFiles = str.join(
        ","
      );
    },
    /**
     * @description: 执业证上传
     * @event:
     * @param {*}
     * @return {*}
     */
    practiceUploadImage(response) {
      if (response.code == 0) {
        // setTimeout(() => {

        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.practice.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.practice.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.practice.watermarkFiles = arr.join(
            ","
          );
        }
        return this.doctorCertificateSubmitDTO.practice.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    practicebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(
        ","
      );
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.practice.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.practice.watermarkFiles = str;
    },
    /**
     * @description: 职称证上传
     * @event:
     * @param {*} e
     * @return {*}
     */
    certificatePracticeResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.title.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.title.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.title.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.title.watermarkFiles = arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.title.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificatePracticebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.title.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.title.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.title.watermarkFiles = str;
    },

    // 胸牌
    certificateNameBadgeResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles = arr.join(
            ","
          );
        }
        return this.doctorCertificateSubmitDTO.nameBadge.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificateNameBadgebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles.split(
        ","
      );
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.title.watermarkFiles = str;
    },

    /**
     * @description: 其他相关证书上传
     * @event:
     * @param {*} e
     * @return {*}
     */
    certificateOtherUplod(response) {
      if (response.code == 0) {
        if (this.doctorCertificateSubmitDTO.other.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.other.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr = this.doctorCertificateSubmitDTO.other.watermarkFiles.split(
            ","
          );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.other.watermarkFiles = arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.other.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificateOtherbeforeRemove(file, fileList, index) {
      let str = this.doctorCertificateSubmitDTO.other.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.other.watermarkFiles = str.join(",");
    },

    /**
     * 关闭大弹窗的回调
     */
    closeDialog() {
      // this.drawer = false
      this.$refs.scrollMenuRef.wrap.scrollTop = 0; //TODO 关闭弹窗 需要把scroll的滚动的距离初始化
      this.$refs.scrollMenuRefB.wrap.scrollTop = 1; //TODO 关闭弹窗 需要把scroll的滚动的距离初始化

      this.isEdit = true; //修改只读状态

      this.information = this.$options.data().information; //清空医护信息内容
      (this.informationCopy = {}), //清空拷贝医护信息
        (this.idCard = this.$options.data().idCard); //清空身份证信息
      this.other = this.$options.data().other; //清空其他证件信息
      this.practice = this.$options.data().practice; //清空资格证信息
      this.qualification = this.$options.data().qualification; //清空执业证信息
      this.title = this.$options.data().title; //清空职称证信息

      this.addplatform = this.$options.data().addplatform; //清空互医平台信息
      this.imgBaseURLArray = this.$options.data().imgBaseURLArray; //清空拷贝专业资质信息
      this.activeName = "details";
      // 移除校验
      this.$refs.qualificationRef.clearValidate();
      this.$refs.practiceRef.clearValidate();
    },

    /**
     * @description: 获取职称段位
     * @param {*}
     * @return {*}
     */
    getDoctorTitle(t) {
      doctor_title(t).then(res => {
        if (res.code == 0) {
          this.doctorTitleList = res.data;
        }
      });
    },

    /**
     * @description: 获取实体医院列表
     * @param {*}
     * @return {*}
     */
    getEntityHospital() {
      api_hospital({}).then(res => {
        if (res.code == 0) {
          this.hospitalList = res.data;
          if (this.$route.query.id) {
            this.formInline.hospitalId = this.$route.query.id;
          }
        }
      });
    },

    /**
     * @description: 改变实体医院后得到该医院下的科室
     * @param {*}
     * @return {*}
     */
    hospitalChange(val) {
      this.hospitalId = val;
      if (this.information1.doctorType == 2) {
        // getHaveNursingService(val).then(res=>{
        // 	this.haveService = res.data
        // })
      }
      this.hospitalList.forEach(item => {
        if (item.id == val) {
          this.doctorTeam.hospitalId = item.id;
          this.doctorTeam.hospitalName = item.name;
        }
      });
      this.information1.hospitalName = "";
      for (var i = 0; i < this.hospitalList.length; i++) {
        if (
          this.hospitalList[i].id == val ||
          this.hospitalList[i].id == this.information1.hospitalId
        ) {
          this.information1.hospitalName = this.hospitalList[i].name;
        }
      }
      this.apiDoctorTeamSearchinit(val);
      if (this.dialogVisible) {
        this.information1.departmentId = "";
      }

      api_department({
        hospitalId: val
      }).then(res => {
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
    },
    departmentChange(val) {
      this.information1.departmentName = "";
      if (!this.$refs["Mycascader"].getCheckedNodes().length) {
        return;
      }
      this.$nextTick(() => {
        this.information1.departmentName = this.$refs[
          "Mycascader"
        ].getCheckedNodes()[0].label;
      });
    },
    doctorTitleChange(v) {
      this.information1.titleName = "";
      for (var i = 0; i < this.doctorTitleList.length; i++) {
        if (this.doctorTitleList[i].id == v) {
          this.information1.titleName = this.doctorTitleList[i].name;
        }
      }
    },

    submiAddCare4(ref) {
      this.$refs[ref].validate(async valid => {
        if (valid) {
          if (!this.upavater) return this.$message.error("请上传医生照片");
          updetaDoctor({
            departmentId: this.information1.departmentId,
            doctorType: this.information1.doctortype,

            hospitalId: this.information1.hospitalId,
            id: this.information1.id,
            idCardNumber: this.information1.idCard,
            introduction: this.information1.note,
            name: this.information1.realName,
            phone: this.information1.phone,
            professional: this.information1.professional,
            provideNursingService: this.information1.provideNursingService,
            serviceScopeKm: this.information1.serviceScopeKm,
            titleId: this.information1.titleId,
            photoUrl: this.upavater.substring(
              process.env.VUE_APP_OSS_URL.length
            ),
            id: this.information1.id
          }).then(res => {
            this.$message.success("操作成功");
            this.isEdit1 = false;
            this.info();
            this.getdetail(this.information1.id);
          });
        } else {
        }
      });
    },
    submiAddCare1(ref) {
      this.$refs[ref].validate(async valid => {
        if (valid) {
          if (!this.upavater) return this.$message.error("请上传医生照片");
          checkIdCardNumber(
            this.information1.idCard,
            this.information1.realName
          ).then(res => {
            this.active = 1;
          });
          if (
            this.information1.hospitalId != this.flagId ||
            this.userPlatForm == "organization"
          ) {
            this.doctorTeam.id = "";
            this.doctorTeam.platformName = "";
            for (var i = 0; i < this.platformOptions.length; i++) {
              if (this.platformOptions[i].id == this.information1.hospitalId) {
                this.doctorTeam.platformName = this.platformOptions[i].name;
              }
            }

            this.departmentList1 = []; //归属科室
            this.caseMgrGroupList = []; //个案组列表
            this.doctorTeam.departmentId = "";
            this.getTreeList(
              this.userPlatForm == "platForm"
                ? this.information1.hospitalId
                : local.get("hospitalId")
            );
            getPlatformOpenDepartmentList({
              hospitalId:
                this.userPlatForm == "platForm"
                  ? this.information1.hospitalId
                  : local.get("hospitalId")
            }).then(res => {
              if (res.code == 0) {
                this.departmentList1 = res.data;
              }
            });
          }
        } else {
        }
      });
    },
    submiAddCare2() {
      if (this.newSelectTteam) {
        if (this.doctorTeam.type == 1) {
          if (!this.doctorTeam.id) {
            return this.$message.error("请选择团队");
          }
        } else {
          if (!this.doctorTeam.name) {
            return this.$message.error("请输入团队名称");
          }
          if (!this.doctorTeam.hospitalId && this.userPlatForm == "platForm") {
            return this.$message.error("请选择线下机构");
          }
          if (!this.doctorTeam.openDepartmentId) {
            return this.$message.error("请选择线下科室");
          }
          if (!this.doctorTeam.caseMgrGroupId) {
            return this.$message.error("请选择个案组");
          }
        }
      }
      if (this.newSelectTteam === "" && this.information1.doctorType != 4) {
        return this.$message.info("请选择是否归属团队");
      }
      this.active = 2;
    },
    submiAddCare5() {
      if (!this.doctorCertificateSubmitDTO.idCard.back) {
        return this.$message.error("请上传国徽面");
      }
      if (!this.doctorCertificateSubmitDTO.idCard.front) {
        return this.$message.error("请上传头像面");
      }
      // if(this.information1.doctorType==1||this.information1.doctorType==2||this.information1.doctorType==4){
      if (
        !this.doctorCertificateSubmitDTO.practice.files.length ||
        this.doctorCertificateSubmitDTO.practice.files.length < 2
      ) {
        return this.$message.error("请按要求上传执业证");
      }
      if (!this.doctorCertificateSubmitDTO.practice.obtainDate) {
        return this.$message.error("请选择发证日期");
      }
      if (
        !this.doctorCertificateSubmitDTO.practice.number ||
        !/^[0-9a-zA-Z]*$/g.test(this.doctorCertificateSubmitDTO.practice.number)
      ) {
        return this.$message.error("请输入数字、字母或数字字母组合证书编号");
      }
      if (
        !this.doctorCertificateSubmitDTO.qualification.files.length ||
        this.doctorCertificateSubmitDTO.qualification.files.length < 2
      ) {
        return this.$message.error("请按要求上传资格证");
      }
      if (!this.doctorCertificateSubmitDTO.qualification.obtainDate) {
        return this.$message.error("请选择发证日期");
      }
      if (
        !this.doctorCertificateSubmitDTO.qualification.number ||
        !/^[0-9a-zA-Z]*$/g.test(
          this.doctorCertificateSubmitDTO.qualification.number
        )
      ) {
        return this.$message.error("请输入数字、字母或数字字母组合证书编号");
      }
      if (!this.doctorCertificateSubmitDTO.nameBadge.files.length) {
        return this.$message.error("请按要求上传胸牌");
      }
      // }
      var doctorCertificateSubmit = {
        idCard: this.doctorCertificateSubmitDTO.idCard,
        other: {
          watermarkFiles: this.doctorCertificateSubmitDTO.other.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.other.files || []
        },
        practice: {
          watermarkFiles: this.doctorCertificateSubmitDTO.practice
            .watermarkFiles,
          files: this.doctorCertificateSubmitDTO.practice.files || []
        },
        qualification: {
          watermarkFiles: this.doctorCertificateSubmitDTO.qualification
            .watermarkFiles,
          files: this.doctorCertificateSubmitDTO.qualification.files || []
        },
        title: {
          watermarkFiles: this.doctorCertificateSubmitDTO.title.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.title.files || []
        },
        nameBadge: {
          watermarkFiles: this.doctorCertificateSubmitDTO.nameBadge
            .watermarkFiles,
          files: this.doctorCertificateSubmitDTO.nameBadge.files || []
        }
      };
      var img = {
        idCard: {
          back: "",
          front: "",
          watermarkFront: "",
          watermarkBack: ""
        },
        other: {
          files: [],
          watermarkFiles: ""
        },
        practice: {
          files: [],
          watermarkFiles: "",
          number: this.doctorCertificateSubmitDTO.practice.number,
          obtainDate: this.doctorCertificateSubmitDTO.practice.obtainDate
            ? this.doctorCertificateSubmitDTO.practice.obtainDate + " 00:00:00"
            : ""
        },
        qualification: {
          files: [],
          watermarkFiles: "",
          number: this.doctorCertificateSubmitDTO.qualification.number,
          obtainDate: this.doctorCertificateSubmitDTO.qualification.obtainDate
            ? this.doctorCertificateSubmitDTO.qualification.obtainDate +
              " 00:00:00"
            : ""
        },
        title: {
          watermarkFiles: "",
          files: []
        },
        nameBadge: {
          watermarkFiles: "",
          files: []
        }
      };
      Object.keys(img).forEach(item => {
        if (item == "idCard") {
          Object.keys(doctorCertificateSubmit[item]).forEach(sub => {
            img[item][sub] = doctorCertificateSubmit[item][sub].substring(
              process.env.VUE_APP_OSS_URL.length
            );
          });
        } else {
          // debugger
          img[item].files =
            doctorCertificateSubmit[item].files.length > 0
              ? doctorCertificateSubmit[item].files
                  .map(items =>
                    items.substring(process.env.VUE_APP_OSS_URL.length)
                  )
                  .join(",")
              : "";
          img[item].watermarkFiles =
            doctorCertificateSubmit[item].watermarkFiles;
        }
      });
      submitCertificate({
        doctorId: this.information1.id,
        ...img
      }).then(res => {
        this.$message.success(`提交成功`);
        this.info();
        this.getdetail(this.information1.id);
        this.isEdit3 = false;
      });
    },
    submiAddCare3() {
      if (!this.doctorCertificateSubmitDTO.idCard.back) {
        return this.$message.error("请上传国徽面");
      }
      if (!this.doctorCertificateSubmitDTO.idCard.front) {
        return this.$message.error("请上传头像面");
      }
      if (
        !this.doctorCertificateSubmitDTO.qualification.files.length ||
        this.doctorCertificateSubmitDTO.qualification.files.length < 2
      ) {
        return this.$message.error("请按要求上传资格证");
      }
      if (!this.doctorCertificateSubmitDTO.qualification.obtainDate) {
        return this.$message.error("请选择发证日期");
      }
      if (
        !this.doctorCertificateSubmitDTO.qualification.number ||
        !/^[0-9a-zA-Z]*$/g.test(
          this.doctorCertificateSubmitDTO.qualification.number
        )
      ) {
        return this.$message.error("请输入数字、字母或数字字母组合证书编号");
      }
      if (
        !this.doctorCertificateSubmitDTO.practice.files.length ||
        this.doctorCertificateSubmitDTO.practice.files.length < 2
      ) {
        return this.$message.error("请按要求上传执业证");
      }
      if (!this.doctorCertificateSubmitDTO.practice.obtainDate) {
        return this.$message.error("请选择发证日期");
      }
      if (
        !this.doctorCertificateSubmitDTO.practice.number ||
        !/^[0-9a-zA-Z]*$/g.test(this.doctorCertificateSubmitDTO.practice.number)
      ) {
        return this.$message.error("请输入数字、字母或数字字母组合证书编号");
      }
      if (!this.doctorCertificateSubmitDTO.nameBadge.files.length) {
        return this.$message.error("请按要求上传胸牌");
      }

      this.active = 3;
    },
    // doctorNurseCreate
    /**
     * 提交新增医护提交
     *
     */
    submiAddCare(ref) {
      if (!this.upavater) return this.$message.error("请上传医生照片");
      this.loadingNew = true;
      this.accountobj.mobile = this.information1.mobile;
      this.infoobj.avatar = this.upavater.substring(
        process.env.VUE_APP_OSS_URL.length
      );
      // let information = {...this.information1};
      if (this.userPlatForm == "organization") {
        this.doctorTeam.hospitalId = local.get("hospitalId");
      }
      this.information1.hospitalId
        ? this.information1.hospitalId
        : (this.information1.hospitalId = local.get("hospitalId"));
      this.infoobj.idCard = this.information1.idCard;
      this.infoobj.mobile = this.information1.mobile;
      this.infoobj.note = this.information1.note;
      this.infoobj.realName = this.information1.realName;
      this.doctorobj.departmentId = this.information1.departmentId;
      this.doctorobj.doctorType = this.information1.doctorType;
      this.doctorobj.hospitalId = this.information1.hospitalId;
      this.doctorobj.professional = this.information1.professional;
      this.doctorobj.titleId = this.information1.titleId;
      this.doctorobj.serviceScopeKm = this.information1.serviceScopeKm;
      this.doctorobj.provideNursingService = this.information1.provideNursingService;
      // return
      var doctorCertificateSubmit = {
        idCard: {
          back: this.doctorCertificateSubmitDTO.idCard.back,
          front: this.doctorCertificateSubmitDTO.idCard.front,
          watermarkBack: this.doctorCertificateSubmitDTO.idCard.watermarkBack,
          watermarkFront: this.doctorCertificateSubmitDTO.idCard.watermarkFront
        },
        other: {
          watermarkFiles: this.doctorCertificateSubmitDTO.other.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.other.files || []
        },
        practice: {
          watermarkFiles: this.doctorCertificateSubmitDTO.practice
            .watermarkFiles,
          files: this.doctorCertificateSubmitDTO.practice.files || []
        },
        qualification: {
          watermarkFiles: this.doctorCertificateSubmitDTO.qualification
            .watermarkFiles,
          files: this.doctorCertificateSubmitDTO.qualification.files || []
        },
        title: {
          watermarkFiles: this.doctorCertificateSubmitDTO.title.watermarkFiles,
          files: this.doctorCertificateSubmitDTO.title.files || []
        },
        nameBadge: {
          watermarkFiles: this.doctorCertificateSubmitDTO.nameBadge
            .watermarkFiles,
          files: this.doctorCertificateSubmitDTO.nameBadge.files || []
        }
      };
      var img = {
        idCard: {
          back: "",
          front: "",
          watermarkFront: "",
          watermarkBack: ""
        },
        other: {
          files: [],
          watermarkFiles: ""
        },
        practice: {
          files: [],
          watermarkFiles: "",
          number: this.doctorCertificateSubmitDTO.practice.number,
          obtainDate: this.doctorCertificateSubmitDTO.practice.obtainDate
            ? this.doctorCertificateSubmitDTO.practice.obtainDate + " 00:00:00"
            : ""
        },
        qualification: {
          files: [],
          watermarkFiles: "",
          number: this.doctorCertificateSubmitDTO.qualification.number,
          obtainDate: this.doctorCertificateSubmitDTO.qualification.obtainDate
            ? this.doctorCertificateSubmitDTO.qualification.obtainDate +
              " 00:00:00"
            : ""
        },
        title: {
          watermarkFiles: "",
          files: []
        },
        nameBadge: {
          watermarkFiles: "",
          files: []
        }
      };
      Object.keys(img).forEach(item => {
        if (item == "idCard") {
          Object.keys(doctorCertificateSubmit[item]).forEach(sub => {
            img[item][sub] = doctorCertificateSubmit[item][sub].substring(
              process.env.VUE_APP_OSS_URL.length
            );
          });
        } else {
          img[item].watermarkFiles =
            doctorCertificateSubmit[item].watermarkFiles;
          // debugger
          img[item].files =
            doctorCertificateSubmit[item].files.length > 0
              ? doctorCertificateSubmit[item].files
                  .map(items =>
                    items.substring(process.env.VUE_APP_OSS_URL.length)
                  )
                  .join(",")
              : "";
        }
      });
      var basicToken =
        "Basic ZHNpY20tYXBwLWRvY3Rvcjpkc2ljbS1hcHAtZG9jdG9yLXB3Jl4kKiZA";
      axios({
        method: "post", // post、get、put....
        url: "/admin/user/create/doctor", // 请求的路径
        headers: {
          Authorization: basicToken
        },
        data: {
          createUserId: local.get("userid"),
          account: this.accountobj,
          doctorInfo: this.information1,
          info: this.infoobj,
          doctorCertificateSubmitDTO: img,
          isMdt: this.information1.doctorType == 1 ? this.isMdt : null,
          doctorTeam: this.newSelectTteam ? this.doctorTeam : null
        }
      })
        .then(res => {
          if (res.data.code === 0) {
            this.loadingNew = false;
            this.$message({
              message: "当前医护信息已提交成功！请耐心等待审核~",
              type: "success"
            });
            this.info();
            this.dialogVisible = false;
            this.information1 = this.$options.data().information1;
          } else {
            this.loadingNew = false;
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(err => {
          this.loadingNew = false;
        });
    },

    selectionChange(e) {},
    getList(e) {
      this.info(e);
    },
    /**
     * @description:首页table事件
     * @event:
     * @param {*} scope
     * @param {*} type
     * @return {*}
     */
    getdetail(data) {
      const machiningFiles = (filesName, type) => {
        if (type)
          return filesName
            .split(",")
            .map(sub => `${process.env.VUE_APP_OSS_URL}` + sub);
        else return filesName.split(",").toString();
      };

      getDoctor(data).then(res => {
        this.$nextTick(() => {
          if (res.data.hospitalId) this.hospitalChange(res.data.hospitalId);
          this.upavater = !!res.data.photoUrl
            ? process.env.VUE_APP_OSS_URL + res.data.photoUrl
            : "";
          this.hospitalObj = res.data.hospital;
          this.information1.mobile = res.data.phone;
          this.information1.realName = res.data.name; //姓名
          (this.information1.idCard = res.data.idCardNumber), //证件 号码
            (this.information1.id = res.data.id);
          // this.information1.photoUrlCopy = "";//用来展示图片
          (this.information1.note = res.data.introduction), //介绍
            (this.information1.departmentId = res.data.departmentId); //科室ID
          this.information1.departmentName = res.data.departmentName;
          this.information1.doctorType = res.data.doctorType; //医护类型1.医生,2.护士,3.医技,4.药师
          this.getDoctorTitle(res.data.doctorType);
          this.information1.hospitalId = res.data.hospitalId; //医院ID
          this.information1.hospitalName = res.data.hospitalName;
          this.information1.professional = res.data.professional; //专业擅长
          this.information1.titleId = res.data.titleId; //职称ID
          this.information1.titleName = res.data.titleName;
          this.information1.serviceScopeKm = res.data.serviceScopeKm; //上门服务km
          this.information1.provideNursingService =
            res.data.provideNursingService;
          this.joinedTeamList = res.data.joinedTeamList
            ? res.data.joinedTeamList
            : [];
          if (res.data.certificateIdCard != null) {
            this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.back}`;
            this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.watermarkBack}`;
            this.doctorCertificateSubmitDTO.idCard.front = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.front}`;
            this.doctorCertificateSubmitDTO.idCard.watermarkFront = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.watermarkFront}`;
          }
          //拷贝资格证信息
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
              res.data.certificateQualification.watermarkFiles;
            this.doctorCertificateSubmitDTO.qualification.files = machiningFiles(
              res.data.certificateQualification.files,
              1
            );
            this.doctorCertificateSubmitDTO.qualification.fileList = res.data.certificateQualification.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.number
          ) {
            this.doctorCertificateSubmitDTO.qualification.number =
              res.data.certificateQualification.number;
          }
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.getDate
          ) {
            this.doctorCertificateSubmitDTO.qualification.obtainDate =
              res.data.certificateQualification.getDate;
          }
          //拷贝执业证信息
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.practice.watermarkFiles =
              res.data.certificatePractice.watermarkFiles;
            this.doctorCertificateSubmitDTO.practice.files = machiningFiles(
              res.data.certificatePractice.files,
              1
            );
            this.doctorCertificateSubmitDTO.practice.fileList = res.data.certificatePractice.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.number
          ) {
            this.doctorCertificateSubmitDTO.practice.number =
              res.data.certificatePractice.number;
          }
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.getDate
          ) {
            this.doctorCertificateSubmitDTO.practice.obtainDate =
              res.data.certificatePractice.getDate;
          }
          //拷贝职业证信息
          if (
            res.data.certificateTitle != null &&
            res.data.certificateTitle.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.title.watermarkFiles =
              res.data.certificateTitle.watermarkFiles;
            this.doctorCertificateSubmitDTO.title.files = machiningFiles(
              res.data.certificateTitle.files,
              1
            );
            this.doctorCertificateSubmitDTO.title.fileList = res.data.certificateTitle.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }
          //拷贝胸牌
          if (
            res.data.certificateNameBadge != null &&
            res.data.certificateNameBadge.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
              res.data.certificateNameBadge.watermarkFiles;
            this.doctorCertificateSubmitDTO.nameBadge.files = machiningFiles(
              res.data.certificateNameBadge.files,
              1
            );
            this.doctorCertificateSubmitDTO.nameBadge.fileList = res.data.certificateNameBadge.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }

          //拷贝其他相关
          if (
            res.data.certificateOther != null &&
            res.data.certificateOther.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.other.watermarkFiles =
              res.data.certificateOther.watermarkFiles;
            this.doctorCertificateSubmitDTO.other.files = machiningFiles(
              res.data.certificateOther.files,
              1
            );
            this.doctorCertificateSubmitDTO.other.fileList = res.data.certificateOther.fileList.map(
              item => {
                return process.env.VUE_APP_OSS_URL + item;
              }
            );
          }
          if (res.code == 0) {
            this.getListByDoctorIdInit();
            //有实体平台的时候，需要根据hospitalId进行查询下级实体科室列表
          }
        });
      });
    },
    hometHandel(scope, type) {
      const scopeItem = scope.row;
      //type 为1 添加oss路径 0 不添加
      const machiningFiles = (filesName, type) => {
        if (type)
          return filesName
            .split(",")
            .map(sub => `${process.env.VUE_APP_OSS_URL}` + sub);
        else return filesName.split(",").toString();
      };
      if (type == "details") {
        //查看详情
        this.newAdd = false;
        this.activeName1 = 1;

        this.$router.push({
          path: "/Organization/updateMedicalinfo",
          query: { id: scope.row.id }
        });

        this.isEdit1 = false;
        this.isEdit2 = false;
        this.isEdit3 = false;
        this.getdetail(scope.row.id);
      } else {
        if (scopeItem.disabled) {
          offEnable(scopeItem.id).then(res => {
            if (res.code == 0) {
              this.$message.success("操作成功");
              scope.row.disabled = !scope.row.disabled;
              this.tableData.splice(scope.$index, 1, scope.row);
            }
          });
        } else {
          offDisable(scopeItem.id).then(res => {
            if (res.code == 0) {
              this.$message.success("操作成功");
              scope.row.disabled = !scope.row.disabled;
              this.tableData.splice(scope.$index, 1, scope.row);
            }
          });
        }
      }
    },

    /**
     *                                           =============================
     *                                           =      医护信息模块          =
     *                                           =============================
     */

    handleMessageResponse1(response) {
      if (response.code == 0) {
        return (this.information.photoUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data);
      }
    },

    handleMessageResponse2(response) {
      if (response.code == 0) {
        return (this.upavater = `${process.env.VUE_APP_OSS_URL}${response.data}`);
      }
    },
    handleMessageResponse3(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },
    handleMessage3beforeRemove(file, fileList, index) {
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = "";
    },
    handleMessageResponse4(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkFront = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.front = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },
    handleMessage4beforeRemove(file, fileList, index) {
      this.doctorCertificateSubmitDTO.idCard.watermarkFront = "";
    },
    /**
     * 加入团队的操作
     *
     */
    resetHandel(scope, type) {
      let scopeItem = scope.row;
      if (type == "reset") {
      } else {
        renmoveDoctor(scopeItem.id).then(res => {
          if (res.code == 0) {
            this.$message.success(`删除成功`);
            let index = this.medicalDetails.joinedTeamList.findIndex(
              item => item.id == scopeItem.id
            );
            this.medicalDetails.joinedTeamList.splice(index, 1);
          }
        });
      }
    },

    //医护人员列表分页查询接口
    info() {
      if (this.$store.state.userPlatForm === "organization") {
        this.searchParams.hospitalId = local.get("hospitalId");
      }
      if (typeof(this.searchParams.certificateStatus) == 'number' ) {
        this.searchParams.certificateStatus = [
          this.searchParams.certificateStatus
        ];
      }  
      if (this.searchParams.disabled == "true") {
        this.searchParams.disabledList = [true];
      }
      if (this.searchParams.disabled == "false") {
        this.searchParams.disabledList = [false];
      }
      api_doctor_search(this.searchParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.totalPage = res.data.total;
        }
      });
    },
    handleTabClick(tab) {
      this.activeName1 = tab;
    },
    //详情按钮
    handleClick(e) {
      this.drawer = true;
    }
  },
  filters: {
    auditDtatus(status) {
      switch (status * 1) {
        case 1:
          return "未提交";
        case 2:
          return "待审核";
        case 3:
          return "通过";
        case 4:
          return "驳回";
        default:
          return "未知状态";
      }
    },
    tagType(status) {
      switch (status * 1) {
        case 1:
          return "success";
        case 2:
          return "info";
        case 3:
          return "";
        case 4:
          return "danger";
        default:
          return "未知状态";
      }
    }
  }
};
</script>
<style type="text/css" lang="less">
.el-step__head.is-success,
.el-step__head.is-process {
  color: #1a7bfc;
  border-color: #1a7bfc;

  .el-step__icon.is-text {
    background: #1a7bfc;
    color: #fff;

    .el-step__icon-inner {
      font-weight: normal;
    }
  }
  .el-step__icon-inner {
    font-weight: normal;
  }
}
.el-step__icon.is-text {
  border: 1px solid !important;
}

.el-step__title.is-success,
.el-step__title.is-process {
  color: #1a7bfc;
}

.el-step__head.is-wait {
  border-color: #d9d9d9;
  color: #666666 !important;
  .el-step__icon-inner {
    font-weight: normal;
  }
}
.el-step__line {
  height: 1px !important;
}

.el-step__title.is-wait {
  color: #363f4d;
}

.lH20 .el-form-item__label {
  width: 120px !important;
  line-height: 20px;
  margin-left: 20px;
}
.organization .el-select {
  width: 100%;
}
.organization .el-cascader {
  width: 100%;
}
</style>
<style lang="less" scoped>
.a-tag {
  border-radius: 11px;
  margin-right: 15px;
}
.float-right {
  float: right;
}
.dialog-footer {
  padding: 20px;
  display: block;
}
.dialog-footer {
  display: block;
  margin-top: 10px;
  padding: 5px 0 10px;
  text-align: center;
  .dialog-btn {
    width: 110px;
    height: 32px;
  }
}
.team-item {
  margin-left: 40px;
  margin-bottom: 20px;
  h3 {
    margin-bottom: 30px;
    font-size: 14px;
  }

  ul {
    display: flex;
    width: 100%;

    li {
      flex: 1;
      font-size: 12px;
      display: flex;
      label {
        white-space: nowrap;
        margin-right: 20px;
      }
    }
  }
}

.tip-zhengshu {
  color: #999999;
}

.label-circle {
  display: flex;
  margin-bottom: 10px;
  height: 25px;
  align-items: center;
  width: 128px;
  flex-flow: row-reverse;

  span:nth-of-type(2) {
    margin-right: 10px;
    width: 6px;
    height: 6px;
    background: #d0e4ff;
    border-radius: 50%;
  }
}

.line-div {
  margin: 40px 0 30px;

  span:nth-of-type(1) {
    display: inline-block;
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 10px;
    vertical-align: middle;
  }

  span:nth-of-type(2) {
    font-weight: bold;
  }
}

.top-tabs {
  display: flex;
  width: 600px;
  padding-top: 40px;

  div {
    cursor: pointer;
    flex: 1;
    line-height: 26px;
  }

  .tabs-cliked {
    color: #1a7bfc;

    span {
      padding-bottom: 4px;
      border-bottom: 2px solid #1a7bfc;
    }
  }

  div:last-of-type {
    min-width: 275px;
  }
}

.btn-view {
  position: absolute;
  right: 25px;
  top: 67px;
  z-index: 1;
}

.organization {
  height: 100%;
  display: flex;
  flex-direction: column;

  & /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
    box-shadow: none;
  }

  .organization-top {
    height: 90px;
    width: 100%;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0px 15px;

    .organization-top-person {
      font-weight: bolder;
      margin-right: 15px;
      flex: 1;
      line-height: 90px;
    }

    .organization-top-search {
      width: 250px;
      line-height: 90px;

      /deep/ .el-input__inner {
        border-radius: 20px;
      }
    }

    .organization-top-btn {
      margin-left: 35px;
      margin-top: 25px;

      /deep/ .el-dropdown {
        margin-left: 20px;

        .el-button {
          border-radius: 20px;
        }
      }
    }

    .organization-top-date {
      margin-left: 35px;
      line-height: 90px;

      .el-date-editor {
        border-radius: 20px;
        border-color: skyblue;
      }
    }
  }

  .organization-content {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    margin: 0 16px;
    .organization-content-top {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
      line-height: 50px;

      .left {
        display: flex;

        div {
          margin-right: 15px;
        }
      }
    }

    .organization-content-toptwo {
      margin-top: 20px;
      border-bottom: 1px solid #ccc;

      .top {
        display: flex;

        div {
          width: 25%;
        }

        .el-button {
          padding: 5px 10px !important;
        }
      }

      .bottom {
        margin-bottom: 15px;
        margin-top: 15px;
        display: flex;

        div {
          width: 25%;
        }

        .el-button {
          padding: 5px 10px !important;
        }
      }
    }

    .organization-content-list {
      margin-top: 15px;
    }

    .cardpage {
      margin-top: 20px;
      text-align: right;
    }

    .department-add {
      .title {
        font-size: 26px;
        text-align: center;
        margin-bottom: 15px;
      }

      /deep/ .el-drawer__body {
        overflow-y: scroll;
        height: 100%;
      }

      .from_btn {
        text-align: right;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .imgup {
        /deep/ .el-upload {
          height: 70px;
          width: 70px;
          display: flex;
          justify-content: center;
          align-items: center;

          i {
            font-size: 16px;
          }
        }
      }
    }
  }

  .no_list {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #cecece;
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .no-number {
    .no-number::-webkit-outer-spin-button,
    .no-number::-webkit-inner-spin-button {
      margin: 0;
      -webkit-appearance: none !important;
    }

    .no-number input[type="number"]::-webkit-outer-spin-button,
    .no-number input[type="number"]::-webkit-inner-spin-button {
      margin: 0;
      -webkit-appearance: none !important;
    }

    .no-number {
      -moz-appearance: textfield;
    }

    .no-number input[type="number"] {
      -moz-appearance: textfield;
    }
  }
}

.basefilt {
  margin-bottom: 0 !important;
}

.drawer-last {
  & /deep/ .el-form-item__content {
    width: 173px;
  }
  .box {
    margin-top: 65px;

    & /deep/ .el-form-item__content {
      width: 89%;
    }

    .from_btn {
      text-align: right;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.date-tips {
  /deep/.el-form-item__label {
    text-align: right !important;
  }
}
.text {
  color: #333333;
  font-size: 14px;
  line-height: 22px;
  padding-bottom: 20px;
  // border-bottom: 16px solid #F8F8F8;
  span:nth-child(2) {
    color: #333;
  }

  span:nth-child(1) {
    color: #999;
  }
}
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
